/* tslint:disable */
/* eslint-disable */
/**
 * MCC Service API
 * Provides endpoints for MCC Dashboard
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: schmiedev@schmiede.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ActuationPerformanceItemDto
 */
export interface ActuationPerformanceItemDto {
    /**
     * 
     * @type {number}
     * @memberof ActuationPerformanceItemDto
     */
    'successPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof ActuationPerformanceItemDto
     */
    'totalTargets': number;
}
/**
 * 
 * @export
 * @interface AggregateModuleRunMetricTotalsResponseDto
 */
export interface AggregateModuleRunMetricTotalsResponseDto {
    /**
     * 
     * @type {AggregateModuleRunMetricTotalsResponseDtoAllTime}
     * @memberof AggregateModuleRunMetricTotalsResponseDto
     */
    'allTime': AggregateModuleRunMetricTotalsResponseDtoAllTime;
    /**
     * 
     * @type {AggregateModuleRunMetricTotalsResponseDtoAllTime}
     * @memberof AggregateModuleRunMetricTotalsResponseDto
     */
    'thisWeek': AggregateModuleRunMetricTotalsResponseDtoAllTime;
    /**
     * 
     * @type {AggregateModuleRunMetricTotalsResponseDtoAllTime}
     * @memberof AggregateModuleRunMetricTotalsResponseDto
     */
    'thisMonth': AggregateModuleRunMetricTotalsResponseDtoAllTime;
}
/**
 * 
 * @export
 * @interface AggregateModuleRunMetricTotalsResponseDtoAllTime
 */
export interface AggregateModuleRunMetricTotalsResponseDtoAllTime {
    /**
     * 
     * @type {number}
     * @memberof AggregateModuleRunMetricTotalsResponseDtoAllTime
     */
    'massKg'?: number;
}
/**
 * 
 * @export
 * @interface AggregateModuleRunsRequestDto
 */
export interface AggregateModuleRunsRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AggregateModuleRunsRequestDto
     */
    'runIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsRequestDto
     */
    'moduleId': string;
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsRequestDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsRequestDto
     */
    'endTime'?: string;
}
/**
 * 
 * @export
 * @interface AggregateModuleRunsResponseDto
 */
export interface AggregateModuleRunsResponseDto {
    /**
     * 
     * @type {{ [key: string]: ActuationPerformanceItemDto; }}
     * @memberof AggregateModuleRunsResponseDto
     */
    'actuationPerformance': { [key: string]: ActuationPerformanceItemDto; };
    /**
     * 
     * @type {Array<string>}
     * @memberof AggregateModuleRunsResponseDto
     */
    'programs': Array<string>;
    /**
     * 
     * @type {AggregateModuleRunsResponseDtoStartTime}
     * @memberof AggregateModuleRunsResponseDto
     */
    'startTime': AggregateModuleRunsResponseDtoStartTime;
    /**
     * 
     * @type {AggregateModuleRunsResponseDtoStartTime}
     * @memberof AggregateModuleRunsResponseDto
     */
    'endTime': AggregateModuleRunsResponseDtoStartTime;
    /**
     * 
     * @type {AggregateModuleRunsResponseDtoRunTime}
     * @memberof AggregateModuleRunsResponseDto
     */
    'runTime': AggregateModuleRunsResponseDtoRunTime;
    /**
     * 
     * @type {AggregateModuleRunsResponseDtoTotals}
     * @memberof AggregateModuleRunsResponseDto
     */
    'totals': AggregateModuleRunsResponseDtoTotals;
    /**
     * 
     * @type {Array<string>}
     * @memberof AggregateModuleRunsResponseDto
     */
    'runIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsResponseDto
     */
    'moduleId': string;
    /**
     * 
     * @type {boolean}
     * @memberof AggregateModuleRunsResponseDto
     */
    'areAllTargetsSame': boolean;
}
/**
 * 
 * @export
 * @interface AggregateModuleRunsResponseDtoRunTime
 */
export interface AggregateModuleRunsResponseDtoRunTime {
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsResponseDtoRunTime
     */
    'days'?: string;
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsResponseDtoRunTime
     */
    'hours'?: string;
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsResponseDtoRunTime
     */
    'minutes'?: string;
}
/**
 * 
 * @export
 * @interface AggregateModuleRunsResponseDtoStartTime
 */
export interface AggregateModuleRunsResponseDtoStartTime {
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsResponseDtoStartTime
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof AggregateModuleRunsResponseDtoStartTime
     */
    'time'?: string;
}
/**
 * 
 * @export
 * @interface AggregateModuleRunsResponseDtoTotals
 */
export interface AggregateModuleRunsResponseDtoTotals {
    /**
     * 
     * @type {object}
     * @memberof AggregateModuleRunsResponseDtoTotals
     */
    'byLabel'?: object;
    /**
     * 
     * @type {object}
     * @memberof AggregateModuleRunsResponseDtoTotals
     */
    'byQuality'?: object;
    /**
     * 
     * @type {number}
     * @memberof AggregateModuleRunsResponseDtoTotals
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AggregateModuleRunsResponseDtoTotals
     */
    'mass'?: number;
}
/**
 * 
 * @export
 * @interface AllUsersModuleDto
 */
export interface AllUsersModuleDto {
    /**
     *
     * @type {string}
     * @memberof AllUsersModuleDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof AllUsersModuleDto
     */
    'name': string | null;
    /**
     *
     * @type {string}
     * @memberof AllUsersModuleDto
     */
    'serialNumber': string | null;
}
/**
 * 
 * @export
 * @interface AllUsersResponseDto
 */
export interface AllUsersResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'firstName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'lastName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AllUsersResponseDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {Array<AllUsersModuleDto>}
     * @memberof AllUsersResponseDto
     */
    'modules': Array<AllUsersModuleDto>;
}
/**
 * 
 * @export
 * @interface ArtifactThresholdDto
 */
export interface ArtifactThresholdDto {
    /**
     * 
     * @type {string}
     * @memberof ArtifactThresholdDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactThresholdDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ArtifactThresholdDto
     */
    'percentThreshold': number;
    /**
     * 
     * @type {boolean}
     * @memberof ArtifactThresholdDto
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface AssignErrorCodeToModuleDto
 */
export interface AssignErrorCodeToModuleDto {
    /**
     * 
     * @type {boolean}
     * @memberof AssignErrorCodeToModuleDto
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssignErrorCodeToModuleDto
     */
    'isTracked'?: boolean;
}
/**
 * 
 * @export
 * @interface AssignFeatureFlagDto
 */
export interface AssignFeatureFlagDto {
    /**
     * 
     * @type {boolean}
     * @memberof AssignFeatureFlagDto
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface AssignedModuleDto
 */
export interface AssignedModuleDto {
    /**
     * 
     * @type {string}
     * @memberof AssignedModuleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssignedModuleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignedModuleDto
     */
    'imageUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface AugmentedModuleRunDto
 */
export interface AugmentedModuleRunDto {
    /**
     * 
     * @type {ModuleRunDto}
     * @memberof AugmentedModuleRunDto
     */
    'moduleRun': ModuleRunDto;
    /**
     * 
     * @type {ChartDataDto}
     * @memberof AugmentedModuleRunDto
     */
    'chartData': ChartDataDto;
}
/**
 * 
 * @export
 * @interface ChangePasswordRequestDto
 */
export interface ChangePasswordRequestDto {
    /**
     *
     * @type {string}
     * @memberof ChangePasswordRequestDto
     */
    'currentPassword': string;
    /**
     *
     * @type {string}
     * @memberof ChangePasswordRequestDto
     */
    'newPassword': string;
}
/**
 * Hand-added ahead of a real openapi:generate run - see this repo's CLAUDE.md
 * "Generated API client" section. mcc-backend's UsersController grew
 * subscribeToPush/unsubscribeFromPush but hasn't been deployed to a real
 * environment yet, so operationIds can't be regenerated correctly.
 * @export
 * @interface SubscribeToPushRequestDto
 */
export interface SubscribeToPushRequestDto {
    /**
     *
     * @type {string}
     * @memberof SubscribeToPushRequestDto
     */
    'endpoint': string;
    /**
     *
     * @type {string}
     * @memberof SubscribeToPushRequestDto
     */
    'p256dh': string;
    /**
     *
     * @type {string}
     * @memberof SubscribeToPushRequestDto
     */
    'auth': string;
}
/**
 * @export
 * @interface UnsubscribeFromPushRequestDto
 */
export interface UnsubscribeFromPushRequestDto {
    /**
     *
     * @type {string}
     * @memberof UnsubscribeFromPushRequestDto
     */
    'endpoint': string;
}
/**
 * 
 * @export
 * @interface ChartDataDto
 */
export interface ChartDataDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof ChartDataDto
     */
    'badProductsPerHour': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ChartDataDto
     */
    'badProductMassPerHour': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ChartDataDto
     */
    'goodProductsPerHour': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ChartDataDto
     */
    'goodProductMassPerHour': Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChartDataDto
     */
    'goodProductsPerHourTime': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ChartDataDto
     */
    'totalGoodProductMass': number;
    /**
     * 
     * @type {number}
     * @memberof ChartDataDto
     */
    'totalBadProductMass': number;
    /**
     * 
     * @type {number}
     * @memberof ChartDataDto
     */
    'totalGoodProducts': number;
    /**
     * 
     * @type {number}
     * @memberof ChartDataDto
     */
    'totalBadProducts': number;
}
/**
 * 
 * @export
 * @interface ClassDistributionDto
 */
export interface ClassDistributionDto {
    /**
     * 
     * @type {string}
     * @memberof ClassDistributionDto
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof ClassDistributionDto
     */
    'percent': number;
    /**
     * 
     * @type {number}
     * @memberof ClassDistributionDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof ClassDistributionDto
     */
    'totalWeight': number;
}
/**
 * 
 * @export
 * @interface CreateErrorCodeDto
 */
export interface CreateErrorCodeDto {
    /**
     *
     * @type {string}
     * @memberof CreateErrorCodeDto
     */
    'code': string;
    /**
     *
     * @type {boolean}
     * @memberof CreateErrorCodeDto
     */
    'adminOnly'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateFeatureFlagDto
 */
export interface CreateFeatureFlagDto {
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureFlagDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFeatureFlagDto
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateModuleDto
 */
export interface CreateModuleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateModuleDto
     */
    'type'?: CreateModuleDtoTypeEnum;
    /**
     * 
     * @type {CreteModuleNotificationSettingsDto}
     * @memberof CreateModuleDto
     */
    'notificationSettings'?: CreteModuleNotificationSettingsDto;
    /**
     * 
     * @type {boolean}
     * @memberof CreateModuleDto
     */
    'shouldDisplayLiveData'?: boolean;
    /**
     * The id of the user this module should belong to
     * @type {string}
     * @memberof CreateModuleDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateModuleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateModuleDto
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateModuleDto
     */
    'imageKey'?: string;
    /**
     *
     * @type {string}
     * @memberof CreateModuleDto
     */
    'serialNumber'?: string;
}

export const CreateModuleDtoTypeEnum = {
    Farmsort: 'FARMSORT',
    Camera: 'CAMERA',
    NotAssigned: 'NOT_ASSIGNED'
} as const;

export type CreateModuleDtoTypeEnum = typeof CreateModuleDtoTypeEnum[keyof typeof CreateModuleDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateTranslationDto
 */
export interface CreateTranslationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTranslationDto
     */
    'key': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateTranslationDto
     */
    'values': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface CreateUserDto
 */
export interface CreateUserDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'languageCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'role': CreateUserDtoRoleEnum;
}

export const CreateUserDtoRoleEnum = {
    Admin: 'ADMIN',
    Customer: 'CUSTOMER',
    DemoUser: 'DEMO_USER',
    Test: 'TEST'
} as const;

export type CreateUserDtoRoleEnum = typeof CreateUserDtoRoleEnum[keyof typeof CreateUserDtoRoleEnum];

/**
 * 
 * @export
 * @interface CreateVideoJobDto
 */
export interface CreateVideoJobDto {
    /**
     * 
     * @type {string}
     * @memberof CreateVideoJobDto
     */
    'moduleId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateVideoJobDto
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof CreateVideoJobDto
     */
    'endTime': string;
}
/**
 * 
 * @export
 * @interface CreteModuleNotificationSettingsDto
 */
export interface CreteModuleNotificationSettingsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreteModuleNotificationSettingsDto
     */
    'emails'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreteModuleNotificationSettingsDto
     */
    'phoneNumbers'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreteModuleNotificationSettingsDto
     */
    'useDefaultNotificationSettings'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreteModuleNotificationSettingsDto
     */
    'emailNotificationsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreteModuleNotificationSettingsDto
     */
    'smsNotificationsEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface CurrentUserModuleResponseDto
 */
export interface CurrentUserModuleResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CurrentUserModuleResponseDto
     */
    'type'?: CurrentUserModuleResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserModuleResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserModuleResponseDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUserModuleResponseDto
     */
    'shouldDisplayLiveData': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CurrentUserModuleResponseDto
     */
    'featureFlags': Array<string>;
}

export const CurrentUserModuleResponseDtoTypeEnum = {
    Farmsort: 'FARMSORT',
    Camera: 'CAMERA',
    NotAssigned: 'NOT_ASSIGNED'
} as const;

export type CurrentUserModuleResponseDtoTypeEnum = typeof CurrentUserModuleResponseDtoTypeEnum[keyof typeof CurrentUserModuleResponseDtoTypeEnum];

/**
 * 
 * @export
 * @interface CurrentUserResponseDto
 */
export interface CurrentUserResponseDto {
    /**
     * 
     * @type {Array<CurrentUserModuleResponseDto>}
     * @memberof CurrentUserResponseDto
     */
    'modules': Array<CurrentUserModuleResponseDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CurrentUserResponseDto
     */
    'featureFlags': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponseDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponseDto
     */
    'firstName': string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponseDto
     */
    'lastName': string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponseDto
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponseDto
     */
    'languageCode': string;
}
/**
 * 
 * @export
 * @interface DefaultNotificationSettingsDto
 */
export interface DefaultNotificationSettingsDto {
    /**
     * 
     * @type {boolean}
     * @memberof DefaultNotificationSettingsDto
     */
    'emailNotificationEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultNotificationSettingsDto
     */
    'smsNotificationEnabled': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultNotificationSettingsDto
     */
    'phoneNumbers': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultNotificationSettingsDto
     */
    'emails': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DefaultNotificationSettingsDto
     */
    'dndStart': string | null;
    /**
     * 
     * @type {string}
     * @memberof DefaultNotificationSettingsDto
     */
    'dndEnd': string | null;
}
/**
 * 
 * @export
 * @interface ErrorCodeAssignmentDto
 */
export interface ErrorCodeAssignmentDto {
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeAssignmentDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeAssignmentDto
     */
    'moduleId': string;
    /**
     * 
     * @type {AssignedModuleDto}
     * @memberof ErrorCodeAssignmentDto
     */
    'module': AssignedModuleDto;
    /**
     * 
     * @type {boolean}
     * @memberof ErrorCodeAssignmentDto
     */
    'enabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ErrorCodeAssignmentDto
     */
    'isTracked': boolean;
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeAssignmentDto
     */
    'lastNotificationAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeAssignmentDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeAssignmentDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ErrorCodeDetailDto
 */
export interface ErrorCodeDetailDto {
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeDetailDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeDetailDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeDetailDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof ErrorCodeDetailDto
     */
    'adminOnly': boolean;
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeDetailDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeDetailDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {Array<ErrorCodeAssignmentDto>}
     * @memberof ErrorCodeDetailDto
     */
    'assignments': Array<ErrorCodeAssignmentDto>;
}
/**
 * 
 * @export
 * @interface ErrorCodeDto
 */
export interface ErrorCodeDto {
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeDto
     */
    'code': string;
    /**
     *
     * @type {string}
     * @memberof ErrorCodeDto
     */
    'name': string | null;
    /**
     *
     * @type {boolean}
     * @memberof ErrorCodeDto
     */
    'adminOnly': boolean;
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ThresholdSettingErrorCodeDto
 */
export interface ThresholdSettingErrorCodeDto {
    /**
     * 
     * @type {string}
     * @memberof ThresholdSettingErrorCodeDto
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof ThresholdSettingErrorCodeDto
     */
    'isTracked': boolean;
    /**
     * 
     * @type {string}
     * @memberof ThresholdSettingErrorCodeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ThresholdSettingErrorCodeDto
     */
    'code': string;
    /**
     * 
     * @type {boolean}
     * @memberof ThresholdSettingErrorCodeDto
     */
    'enabled': boolean;
}
/**
 *
 * @export
 * @interface ThresholdSettingFlowControlSensorDto
 */
export interface ThresholdSettingFlowControlSensorDto {
    /**
     *
     * @type {string}
     * @memberof ThresholdSettingFlowControlSensorDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof ThresholdSettingFlowControlSensorDto
     */
    'unit': string;
    /**
     *
     * @type {string}
     * @memberof ThresholdSettingFlowControlSensorDto
     */
    'position': string;
    /**
     *
     * @type {boolean}
     * @memberof ThresholdSettingFlowControlSensorDto
     */
    'enabled': boolean;
}
/**
 *
 * @export
 * @interface FeatureFlagDetailDto
 */
export interface FeatureFlagDetailDto {
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagDetailDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagDetailDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureFlagDetailDto
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagDetailDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagDetailDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {Array<FeatureFlagModuleAssignmentDto>}
     * @memberof FeatureFlagDetailDto
     */
    'moduleAssignments': Array<FeatureFlagModuleAssignmentDto>;
    /**
     * 
     * @type {Array<FeatureFlagUserAssignmentDto>}
     * @memberof FeatureFlagDetailDto
     */
    'userAssignments': Array<FeatureFlagUserAssignmentDto>;
}
/**
 * 
 * @export
 * @interface FeatureFlagDto
 */
export interface FeatureFlagDto {
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureFlagDto
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface FeatureFlagModuleAssignmentDto
 */
export interface FeatureFlagModuleAssignmentDto {
    /**
     * The id of the assignment record itself
     * @type {string}
     * @memberof FeatureFlagModuleAssignmentDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagModuleAssignmentDto
     */
    'moduleId': string;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagModuleAssignmentDto
     */
    'moduleName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureFlagModuleAssignmentDto
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface FeatureFlagUserAssignmentDto
 */
export interface FeatureFlagUserAssignmentDto {
    /**
     * The id of the assignment record itself
     * @type {string}
     * @memberof FeatureFlagUserAssignmentDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagUserAssignmentDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagUserAssignmentDto
     */
    'username': string;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureFlagUserAssignmentDto
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface FindChartDataForRunIdDto
 */
export interface FindChartDataForRunIdDto {
    /**
     * 
     * @type {FindChartDataForRunIdDtoChartData}
     * @memberof FindChartDataForRunIdDto
     */
    'chartData': FindChartDataForRunIdDtoChartData;
}
/**
 * 
 * @export
 * @interface FindChartDataForRunIdDtoChartData
 */
export interface FindChartDataForRunIdDtoChartData {
    /**
     * 
     * @type {Array<number>}
     * @memberof FindChartDataForRunIdDtoChartData
     */
    'badProductMassPerHour'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof FindChartDataForRunIdDtoChartData
     */
    'badProductsPerHour'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof FindChartDataForRunIdDtoChartData
     */
    'goodProductMassPerHour'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof FindChartDataForRunIdDtoChartData
     */
    'goodProductsPerHour'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindChartDataForRunIdDtoChartData
     */
    'goodProductsPerHourTime'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FindChartDataForRunIdDtoChartData
     */
    'runDate'?: string;
}
/**
 * 
 * @export
 * @interface GetPresignedUploadUrlResponseDto
 */
export interface GetPresignedUploadUrlResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetPresignedUploadUrlResponseDto
     */
    'imageKey': string;
    /**
     * 
     * @type {string}
     * @memberof GetPresignedUploadUrlResponseDto
     */
    'mimeType': string;
    /**
     * 
     * @type {string}
     * @memberof GetPresignedUploadUrlResponseDto
     */
    'uploadUrl': string;
}
/**
 * 
 * @export
 * @interface HealthControllerGetHealth200Response
 */
export interface HealthControllerGetHealth200Response {
    /**
     * 
     * @type {string}
     * @memberof HealthControllerGetHealth200Response
     */
    'status'?: string;
    /**
     * 
     * @type {{ [key: string]: HealthControllerGetHealth200ResponseInfoValue; }}
     * @memberof HealthControllerGetHealth200Response
     */
    'info'?: { [key: string]: HealthControllerGetHealth200ResponseInfoValue; } | null;
    /**
     * 
     * @type {{ [key: string]: HealthControllerGetHealth200ResponseInfoValue; }}
     * @memberof HealthControllerGetHealth200Response
     */
    'error'?: { [key: string]: HealthControllerGetHealth200ResponseInfoValue; } | null;
    /**
     * 
     * @type {{ [key: string]: HealthControllerGetHealth200ResponseInfoValue; }}
     * @memberof HealthControllerGetHealth200Response
     */
    'details'?: { [key: string]: HealthControllerGetHealth200ResponseInfoValue; };
}
/**
 * 
 * @export
 * @interface HealthControllerGetHealth200ResponseInfoValue
 */
export interface HealthControllerGetHealth200ResponseInfoValue {
    [key: string]: string | any;

    /**
     * 
     * @type {string}
     * @memberof HealthControllerGetHealth200ResponseInfoValue
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface HealthControllerGetHealth503Response
 */
export interface HealthControllerGetHealth503Response {
    /**
     * 
     * @type {string}
     * @memberof HealthControllerGetHealth503Response
     */
    'status'?: string;
    /**
     * 
     * @type {{ [key: string]: HealthControllerGetHealth200ResponseInfoValue; }}
     * @memberof HealthControllerGetHealth503Response
     */
    'info'?: { [key: string]: HealthControllerGetHealth200ResponseInfoValue; } | null;
    /**
     * 
     * @type {{ [key: string]: HealthControllerGetHealth200ResponseInfoValue; }}
     * @memberof HealthControllerGetHealth503Response
     */
    'error'?: { [key: string]: HealthControllerGetHealth200ResponseInfoValue; } | null;
    /**
     * 
     * @type {{ [key: string]: HealthControllerGetHealth200ResponseInfoValue; }}
     * @memberof HealthControllerGetHealth503Response
     */
    'details'?: { [key: string]: HealthControllerGetHealth200ResponseInfoValue; };
}
/**
 * 
 * @export
 * @interface IntervallNotificationSettingsRequestDto
 */
export interface IntervallNotificationSettingsRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IntervallNotificationSettingsRequestDto
     */
    'intervalInMinutes': number;
}
/**
 * 
 * @export
 * @interface ListAllUsersResponseDto
 */
export interface ListAllUsersResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ListAllUsersResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ListAllUsersResponseDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ListAllUsersResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof ListAllUsersResponseDto
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<AllUsersResponseDto>}
     * @memberof ListAllUsersResponseDto
     */
    'results': Array<AllUsersResponseDto>;
}
/**
 * 
 * @export
 * @interface ListErrorCodesResponseDto
 */
export interface ListErrorCodesResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ListErrorCodesResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ListErrorCodesResponseDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ListErrorCodesResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof ListErrorCodesResponseDto
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<ErrorCodeDto>}
     * @memberof ListErrorCodesResponseDto
     */
    'results': Array<ErrorCodeDto>;
}
/**
 * 
 * @export
 * @interface ListFeatureFlagsResponseDto
 */
export interface ListFeatureFlagsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ListFeatureFlagsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ListFeatureFlagsResponseDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ListFeatureFlagsResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof ListFeatureFlagsResponseDto
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<FeatureFlagDto>}
     * @memberof ListFeatureFlagsResponseDto
     */
    'results': Array<FeatureFlagDto>;
}
/**
 * 
 * @export
 * @interface ListModuleNotificationSettingsResponseDto
 */
export interface ListModuleNotificationSettingsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ListModuleNotificationSettingsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ListModuleNotificationSettingsResponseDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ListModuleNotificationSettingsResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof ListModuleNotificationSettingsResponseDto
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<ModuleNotificationSettingsDto>}
     * @memberof ListModuleNotificationSettingsResponseDto
     */
    'results': Array<ModuleNotificationSettingsDto>;
}
/**
 * 
 * @export
 * @interface ListModuleRunsRequestDto
 */
export interface ListModuleRunsRequestDto {
    /**
     * current page
     * @type {number}
     * @memberof ListModuleRunsRequestDto
     */
    'page'?: number;
    /**
     * rows per page
     * @type {number}
     * @memberof ListModuleRunsRequestDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListModuleRunsRequestDto
     */
    'program'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListModuleRunsRequestDto
     */
    'runIntervalStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListModuleRunsRequestDto
     */
    'runIntervalEnd'?: string;
    /**
     * 
     * @type {ListModuleRunsSortCriteriaDto}
     * @memberof ListModuleRunsRequestDto
     */
    'sortBy'?: ListModuleRunsSortCriteriaDto;
    /**
     * 
     * @type {boolean}
     * @memberof ListModuleRunsRequestDto
     */
    'filterSmallRuns'?: boolean;
}
/**
 * 
 * @export
 * @interface ListModuleRunsResponseDto
 */
export interface ListModuleRunsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ListModuleRunsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ListModuleRunsResponseDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ListModuleRunsResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof ListModuleRunsResponseDto
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<ModuleRunsDto>}
     * @memberof ListModuleRunsResponseDto
     */
    'results': Array<ModuleRunsDto>;
}
/**
 * 
 * @export
 * @interface ListModuleRunsSortCriteriaDto
 */
export interface ListModuleRunsSortCriteriaDto {
    /**
     * 
     * @type {boolean}
     * @memberof ListModuleRunsSortCriteriaDto
     */
    'program'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListModuleRunsSortCriteriaDto
     */
    'startTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListModuleRunsSortCriteriaDto
     */
    'duration'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListModuleRunsSortCriteriaDto
     */
    'totalCount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListModuleRunsSortCriteriaDto
     */
    'totalMass'?: boolean;
}
/**
 * 
 * @export
 * @interface ListModulesResponseDto
 */
export interface ListModulesResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ListModulesResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ListModulesResponseDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ListModulesResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof ListModulesResponseDto
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<ModuleDto>}
     * @memberof ListModulesResponseDto
     */
    'results': Array<ModuleDto>;
}
/**
 * 
 * @export
 * @interface ListNotificationLogResponseDto
 */
export interface ListNotificationLogResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ListNotificationLogResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ListNotificationLogResponseDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ListNotificationLogResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof ListNotificationLogResponseDto
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<NotificationLogDto>}
     * @memberof ListNotificationLogResponseDto
     */
    'results': Array<NotificationLogDto>;
}
/**
 * 
 * @export
 * @interface ListNotificationRequestFiltersDto
 */
export interface ListNotificationRequestFiltersDto {
    /**
     *
     * @type {Array<NotificationCategory>}
     * @memberof ListNotificationRequestFiltersDto
     */
    'categories'?: Array<NotificationCategory>;
    /**
     * required if \"dateTo\" passed
     * @type {string}
     * @memberof ListNotificationRequestFiltersDto
     */
    'dateFrom'?: string;
    /**
     * required if \"dateFrom\" passed
     * @type {string}
     * @memberof ListNotificationRequestFiltersDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ListNotificationRequestFiltersDto
     */
    'isRead'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListNotificationRequestFiltersDto
     */
    'moduleId'?: string;
}

export const NotificationCategory = {
    Error: 'error',
    ErrorResolved: 'error_resolved',
    FlowControl: 'flow_control',
    FlowControlResolved: 'flow_control_resolved'
} as const;

export type NotificationCategory = typeof NotificationCategory[keyof typeof NotificationCategory];

/**
 *
 * @export
 * @enum {string}
 */

export const ListNotificationRequestScope = {
    Module: 'MODULE',
    User: 'USER'
} as const;

export type ListNotificationRequestScope = typeof ListNotificationRequestScope[keyof typeof ListNotificationRequestScope];


/**
 * 
 * @export
 * @interface ListNotificationsRequestDto
 */
export interface ListNotificationsRequestDto {
    /**
     * current page
     * @type {number}
     * @memberof ListNotificationsRequestDto
     */
    'page'?: number;
    /**
     * rows per page
     * @type {number}
     * @memberof ListNotificationsRequestDto
     */
    'limit'?: number;
    /**
     * 
     * @type {ListNotificationRequestScope}
     * @memberof ListNotificationsRequestDto
     */
    'scope': ListNotificationRequestScope;
    /**
     * 
     * @type {ListNotificationRequestFiltersDto}
     * @memberof ListNotificationsRequestDto
     */
    'filters'?: ListNotificationRequestFiltersDto;
}
/**
 * 
 * @export
 * @interface ListNotificationsResponseDto
 */
export interface ListNotificationsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ListNotificationsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ListNotificationsResponseDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ListNotificationsResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof ListNotificationsResponseDto
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<NotificationDto>}
     * @memberof ListNotificationsResponseDto
     */
    'results': Array<NotificationDto>;
}
/**
 * 
 * @export
 * @interface ListTranslationsResponseDto
 */
export interface ListTranslationsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ListTranslationsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ListTranslationsResponseDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ListTranslationsResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof ListTranslationsResponseDto
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<TranslationDto>}
     * @memberof ListTranslationsResponseDto
     */
    'results': Array<TranslationDto>;
}
/**
 * 
 * @export
 * @interface ListVideoJobsResponseDto
 */
export interface ListVideoJobsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ListVideoJobsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ListVideoJobsResponseDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ListVideoJobsResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof ListVideoJobsResponseDto
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<VideoJobDto>}
     * @memberof ListVideoJobsResponseDto
     */
    'results': Array<VideoJobDto>;
}
/**
 * 
 * @export
 * @interface LoginRequestDto
 */
export interface LoginRequestDto {
    /**
     * 
     * @type {string}
     * @memberof LoginRequestDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface LoginResponseDto
 */
export interface LoginResponseDto {
    /**
     * auth JWT
     * @type {string}
     * @memberof LoginResponseDto
     */
    'authToken': string;
    /**
     * token expires at (unix timestamp in seconds)
     * @type {number}
     * @memberof LoginResponseDto
     */
    'expiresAt': number;
    /**
     * 
     * @type {boolean}
     * @memberof LoginResponseDto
     */
    'isAdmin': boolean;
}
/**
 * 
 * @export
 * @interface MarkAllNotificationsAsUnread
 */
export interface MarkAllNotificationsAsUnread {
    /**
     * 
     * @type {string}
     * @memberof MarkAllNotificationsAsUnread
     */
    'notificationId': string;
}
/**
 * 
 * @export
 * @interface MimicUserDto
 */
export interface MimicUserDto {
    /**
     * 
     * @type {string}
     * @memberof MimicUserDto
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface ModuleDiagnosticsLastSeenResponseDto
 */
export interface ModuleDiagnosticsLastSeenResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ModuleDiagnosticsLastSeenResponseDto
     */
    'moduleId': string;
    /**
     * 
     * @type {object}
     * @memberof ModuleDiagnosticsLastSeenResponseDto
     */
    'diagnostics': object;
    /**
     * 
     * @type {string}
     * @memberof ModuleDiagnosticsLastSeenResponseDto
     */
    'lastSeenAt': string;
}
/**
 * 
 * @export
 * @interface ModuleDto
 */
export interface ModuleDto {
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'status': ModuleDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'cameraPosition'?: ModuleDtoCameraPositionEnum;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'type'?: ModuleDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'serialNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'workspaceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'imageUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'imageKey': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleDto
     */
    'lastOnlineAt': string | null;
    /**
     * 
     * @type {ModuleDtoOwnerUser}
     * @memberof ModuleDto
     */
    'ownerUser'?: ModuleDtoOwnerUser;
    /**
     * 
     * @type {boolean}
     * @memberof ModuleDto
     */
    'shouldDisplayLiveData': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModuleDto
     */
    'enabled': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleDto
     */
    'featureFlags': Array<string>;
}

export const ModuleDtoStatusEnum = {
    On: 'on',
    Off: 'off'
} as const;

export type ModuleDtoStatusEnum = typeof ModuleDtoStatusEnum[keyof typeof ModuleDtoStatusEnum];
export const ModuleDtoCameraPositionEnum = {
    Bunker: 'BUNKER',
    BoxFiller: 'BOX_FILLER',
    SizeGrader: 'SIZE_GRADER',
    Farmsort: 'FARMSORT'
} as const;

export type ModuleDtoCameraPositionEnum = typeof ModuleDtoCameraPositionEnum[keyof typeof ModuleDtoCameraPositionEnum];
export const ModuleDtoTypeEnum = {
    Farmsort: 'FARMSORT',
    Camera: 'CAMERA',
    NotAssigned: 'NOT_ASSIGNED'
} as const;

export type ModuleDtoTypeEnum = typeof ModuleDtoTypeEnum[keyof typeof ModuleDtoTypeEnum];

/**
 * 
 * @export
 * @interface ModuleDtoOwnerUser
 */
export interface ModuleDtoOwnerUser {
    /**
     * 
     * @type {string}
     * @memberof ModuleDtoOwnerUser
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleDtoOwnerUser
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleDtoOwnerUser
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface ModuleImagePresetDto
 */
export interface ModuleImagePresetDto {
    /**
     * 
     * @type {string}
     * @memberof ModuleImagePresetDto
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleImagePresetDto
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface ModuleNotificationSettingsDefaultSettingsDto
 */
export interface ModuleNotificationSettingsDefaultSettingsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleNotificationSettingsDefaultSettingsDto
     */
    'emails': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleNotificationSettingsDefaultSettingsDto
     */
    'phoneNumbers': Array<string>;
}
/**
 * 
 * @export
 * @interface ModuleNotificationSettingsDto
 */
export interface ModuleNotificationSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof ModuleNotificationSettingsDto
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof ModuleNotificationSettingsDto
     */
    'emailNotificationEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModuleNotificationSettingsDto
     */
    'smsNotificationEnabled': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleNotificationSettingsDto
     */
    'emails': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleNotificationSettingsDto
     */
    'phoneNumbers': Array<string>;
    /**
     * 
     * @type {ModuleNotificationSettingsDtoDefaultNotificationSettings}
     * @memberof ModuleNotificationSettingsDto
     */
    'defaultNotificationSettings': ModuleNotificationSettingsDtoDefaultNotificationSettings | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleNotificationSettingsDto
     */
    'createdAt': string;
    /**
     * 
     * @type {ModuleNotificationSettingsModuleDto}
     * @memberof ModuleNotificationSettingsDto
     */
    'module': ModuleNotificationSettingsModuleDto;
}
/**
 * 
 * @export
 * @interface ModuleNotificationSettingsDtoDefaultNotificationSettings
 */
export interface ModuleNotificationSettingsDtoDefaultNotificationSettings {
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleNotificationSettingsDtoDefaultNotificationSettings
     */
    'emails': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleNotificationSettingsDtoDefaultNotificationSettings
     */
    'phoneNumbers': Array<string>;
}
/**
 * 
 * @export
 * @interface ModuleNotificationSettingsModuleDto
 */
export interface ModuleNotificationSettingsModuleDto {
    /**
     * 
     * @type {string}
     * @memberof ModuleNotificationSettingsModuleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleNotificationSettingsModuleDto
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleNotificationSettingsModuleDto
     */
    'imageUrl': string | null;
}
/**
 * 
 * @export
 * @interface ModuleRunDto
 */
export interface ModuleRunDto {
    /**
     * 
     * @type {string}
     * @memberof ModuleRunDto
     */
    'runId': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunDto
     */
    'moduleId': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunDto
     */
    'program': string | null;
    /**
     * 
     * @type {object}
     * @memberof ModuleRunDto
     */
    'targets': object;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunDto
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunDto
     */
    'lastUpdatedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface ModuleRunMetricDto
 */
export interface ModuleRunMetricDto {
    /**
     * 
     * @type {number}
     * @memberof ModuleRunMetricDto
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunMetricDto
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof ModuleRunMetricDto
     */
    'mass': number;
}
/**
 * 
 * @export
 * @interface ModuleRunsDto
 */
export interface ModuleRunsDto {
    /**
     * 
     * @type {Array<ModuleRunMetricDto>}
     * @memberof ModuleRunsDto
     */
    'metrics': Array<ModuleRunMetricDto>;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunsDto
     */
    'runId': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunsDto
     */
    'moduleId': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunsDto
     */
    'program': string | null;
    /**
     * 
     * @type {object}
     * @memberof ModuleRunsDto
     */
    'targets': object;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunsDto
     */
    'startTime': string;
    /**
     * 
     * @type {object}
     * @memberof ModuleRunsDto
     */
    'module': object;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunsDto
     */
    'lastUpdatedAt': string | null;
    /**
     * 
     * @type {object}
     * @memberof ModuleRunsDto
     */
    'totalCount': object;
    /**
     * 
     * @type {object}
     * @memberof ModuleRunsDto
     */
    'totalMass': object;
    /**
     * 
     * @type {string}
     * @memberof ModuleRunsDto
     */
    'duration': string;
}
/**
 * 
 * @export
 * @interface ModulesErrorSummaryDto
 */
export interface ModulesErrorSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof ModulesErrorSummaryDto
     */
    'moduleId': string;
    /**
     * 
     * @type {string}
     * @memberof ModulesErrorSummaryDto
     */
    'lastName': string;
    /**
     * 
     * @type {number}
     * @memberof ModulesErrorSummaryDto
     */
    'totalAdminErrorsLast7Days': number;
    /**
     * 
     * @type {number}
     * @memberof ModulesErrorSummaryDto
     */
    'totalAdminErrorsToday': number;
    /**
     * 
     * @type {number}
     * @memberof ModulesErrorSummaryDto
     */
    'totalNonAdminErrorsLast7Days': number;
    /**
     * 
     * @type {number}
     * @memberof ModulesErrorSummaryDto
     */
    'totalNonAdminErrorsToday': number;
    /**
     * 
     * @type {number}
     * @memberof ModulesErrorSummaryDto
     */
    'totalAdminOnlyUnread': number;
    /**
     * 
     * @type {string}
     * @memberof ModulesErrorSummaryDto
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface ModulesErrorSummaryRequestDto
 */
export interface ModulesErrorSummaryRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ModulesErrorSummaryRequestDto
     */
    'filteredCodes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ModulesErrorSummaryRequestDto
     */
    'since': string;
    /**
     * 
     * @type {string}
     * @memberof ModulesErrorSummaryRequestDto
     */
    'today': string;
}
/**
 * 
 * @export
 * @interface NotificationDto
 */
export interface NotificationDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'type': NotificationDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'level': NotificationDtoLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'moduleId': string | null;
    /**
     * 
     * @type {NotificationDtoModule}
     * @memberof NotificationDto
     */
    'module': NotificationDtoModule | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationDto
     */
    'isRead': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationDto
     */
    'adminOnly': boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'createdAt': string;
}

export const NotificationDtoTypeEnum = {
    Error: 'module_error',
    TurnedOn: 'module_turned_on',
    TurnedOff: 'module_turned_off'
} as const;

export type NotificationDtoTypeEnum = typeof NotificationDtoTypeEnum[keyof typeof NotificationDtoTypeEnum];
export const NotificationDtoLevelEnum = {
    Info: 'info',
    Warning: 'warning',
    Error: 'error',
    Success: 'success'
} as const;

export type NotificationDtoLevelEnum = typeof NotificationDtoLevelEnum[keyof typeof NotificationDtoLevelEnum];

/**
 * 
 * @export
 * @interface NotificationDtoModule
 */
export interface NotificationDtoModule {
    /**
     * 
     * @type {string}
     * @memberof NotificationDtoModule
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDtoModule
     */
    'name': string | null;
}
/**
 * 
 * @export
 * @interface NotificationLogDto
 */
export interface NotificationLogDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationLogDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationLogDto
     */
    'channel': NotificationLogDtoChannelEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationLogDto
     */
    'notificationType': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationLogDto
     */
    'status': NotificationLogDtoStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationLogDto
     */
    'recipients': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof NotificationLogDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationLogDto
     */
    'moduleId'?: string | null;
    /**
     * 
     * @type {NotificationLogDtoModule}
     * @memberof NotificationLogDto
     */
    'module'?: NotificationLogDtoModule | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationLogDto
     */
    'sentAt': string;
}

export const NotificationLogDtoChannelEnum = {
    Sms: 'SMS',
    Email: 'EMAIL',
    Push: 'PUSH'
} as const;

export type NotificationLogDtoChannelEnum = typeof NotificationLogDtoChannelEnum[keyof typeof NotificationLogDtoChannelEnum];
export const NotificationLogDtoStatusEnum = {
    Success: 'SUCCESS',
    Failed: 'FAILED'
} as const;

export type NotificationLogDtoStatusEnum = typeof NotificationLogDtoStatusEnum[keyof typeof NotificationLogDtoStatusEnum];

/**
 * 
 * @export
 * @interface NotificationLogDtoModule
 */
export interface NotificationLogDtoModule {
    /**
     *
     * @type {string}
     * @memberof NotificationLogDtoModule
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof NotificationLogDtoModule
     */
    'name'?: string | null;
    /**
     *
     * @type {string}
     * @memberof NotificationLogDtoModule
     */
    'serialNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface NotificationLogModuleDto
 */
export interface NotificationLogModuleDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationLogModuleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationLogModuleDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface NotificationModuleDto
 */
export interface NotificationModuleDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationModuleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationModuleDto
     */
    'name': string | null;
}
/**
 * 
 * @export
 * @interface PatchThresholdSettingsRequestDto
 */
export interface PatchThresholdSettingsRequestDto {
    /**
     * 
     * @type {number}
     * @memberof PatchThresholdSettingsRequestDto
     */
    'thresholdValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchThresholdSettingsRequestDto
     */
    'isEnabled': boolean;
}
/**
 * 
 * @export
 * @interface QualicamEntriesResponseDto
 */
export interface QualicamEntriesResponseDto {
    /**
     * 
     * @type {Array<QualicamEntryDto>}
     * @memberof QualicamEntriesResponseDto
     */
    'entries': Array<QualicamEntryDto>;
    /**
     * 
     * @type {boolean}
     * @memberof QualicamEntriesResponseDto
     */
    'hasNextPage': boolean;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntriesResponseDto
     */
    'totalPages': number;
}
/**
 * 
 * @export
 * @interface QualicamEntryDto
 */
export interface QualicamEntryDto {
    /**
     * 
     * @type {string}
     * @memberof QualicamEntryDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QualicamEntryDto
     */
    'imageUrl': string;
    /**
     * 
     * @type {object}
     * @memberof QualicamEntryDto
     */
    'metaData': object;
}
/**
 * 
 * @export
 * @interface QualicamEntryOverviewDto
 */
export interface QualicamEntryOverviewDto {
    /**
     * 
     * @type {string}
     * @memberof QualicamEntryOverviewDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QualicamEntryOverviewDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QualicamEntryOverviewDto
     */
    'imageUrl': string;
    /**
     * 
     * @type {object}
     * @memberof QualicamEntryOverviewDto
     */
    'metaData': object;
    /**
     * 
     * @type {string}
     * @memberof QualicamEntryOverviewDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof QualicamEntryOverviewDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntryOverviewDto
     */
    'duration': number;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntryOverviewDto
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntryOverviewDto
     */
    'totalWeight': number;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntryOverviewDto
     */
    'aStock': number;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntryOverviewDto
     */
    'aStockWeight': number;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntryOverviewDto
     */
    'bStock': number;
    /**
     * 
     * @type {number}
     * @memberof QualicamEntryOverviewDto
     */
    'bStockWeight': number;
    /**
     * 
     * @type {Array<ClassDistributionDto>}
     * @memberof QualicamEntryOverviewDto
     */
    'classDistribution': Array<ClassDistributionDto>;
    /**
     * 
     * @type {Array<SizeDistributionDto>}
     * @memberof QualicamEntryOverviewDto
     */
    'sizeDistribution': Array<SizeDistributionDto>;
}
/**
 * 
 * @export
 * @interface SizeDistributionDto
 */
export interface SizeDistributionDto {
    /**
     * 
     * @type {string}
     * @memberof SizeDistributionDto
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof SizeDistributionDto
     */
    'percent': number;
    /**
     * 
     * @type {number}
     * @memberof SizeDistributionDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof SizeDistributionDto
     */
    'totalWeight': number;
}
/**
 * 
 * @export
 * @interface ThresholdSettingDto
 */
export interface ThresholdSettingDto {
    /**
     * 
     * @type {string}
     * @memberof ThresholdSettingDto
     */
    'moduleId': string;
    /**
     * 
     * @type {ThresholdSettingDtoNotificationSettings}
     * @memberof ThresholdSettingDto
     */
    'notificationSettings': ThresholdSettingDtoNotificationSettings;
}
/**
 * 
 * @export
 * @interface ThresholdSettingDtoNotificationSettings
 */
export interface ThresholdSettingDtoNotificationSettings {
    /**
     * 
     * @type {boolean}
     * @memberof ThresholdSettingDtoNotificationSettings
     */
    'artifactThresholdEnabled'?: boolean;
    /**
     * 
     * @type {Array<ArtifactThresholdDto>}
     * @memberof ThresholdSettingDtoNotificationSettings
     */
    'artifactThresholds'?: Array<ArtifactThresholdDto>;
    /**
     * 
     * @type {Array<ThresholdSettingErrorCodeDto>}
     * @memberof ThresholdSettingDtoNotificationSettings
     */
    'errorCodes'?: Array<ThresholdSettingErrorCodeDto>;
    /**
     *
     * @type {Array<ThresholdSettingFlowControlSensorDto>}
     * @memberof ThresholdSettingDtoNotificationSettings
     */
    'flowControlSensors'?: Array<ThresholdSettingFlowControlSensorDto>;
    /**
     *
     * @type {string}
     * @memberof ThresholdSettingDtoNotificationSettings
     */
    'notificationSettingsId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThresholdSettingDtoNotificationSettings
     */
    'renotifyIntervalMinutes'?: number;
}
/**
 * 
 * @export
 * @interface ToggleModuleNotificationSettingsRequestDto
 */
export interface ToggleModuleNotificationSettingsRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof ToggleModuleNotificationSettingsRequestDto
     */
    'isEnabled': boolean;
}
/**
 * 
 * @export
 * @interface TranslationDto
 */
export interface TranslationDto {
    /**
     * 
     * @type {string}
     * @memberof TranslationDto
     */
    'key': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof TranslationDto
     */
    'values': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof TranslationDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TranslationDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface UpdateDefaultNotificationSettingsRequestDto
 */
export interface UpdateDefaultNotificationSettingsRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDefaultNotificationSettingsRequestDto
     */
    'emails'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDefaultNotificationSettingsRequestDto
     */
    'emailNotificationEnabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDefaultNotificationSettingsRequestDto
     */
    'phoneNumbers'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDefaultNotificationSettingsRequestDto
     */
    'smsNotificationsEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDefaultNotificationSettingsRequestDto
     */
    'dndStart'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDefaultNotificationSettingsRequestDto
     */
    'dndEnd'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateErrorCodeAssignmentDto
 */
export interface UpdateErrorCodeAssignmentDto {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateErrorCodeAssignmentDto
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateErrorCodeAssignmentDto
     */
    'isTracked'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateErrorCodeDto
 */
export interface UpdateErrorCodeDto {
    /**
     *
     * @type {string}
     * @memberof UpdateErrorCodeDto
     */
    'code'?: string;
    /**
     *
     * @type {boolean}
     * @memberof UpdateErrorCodeDto
     */
    'adminOnly'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateFeatureFlagAssignmentDto
 */
export interface UpdateFeatureFlagAssignmentDto {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeatureFlagAssignmentDto
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface UpdateFeatureFlagDto
 */
export interface UpdateFeatureFlagDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateFeatureFlagDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeatureFlagDto
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateLanguageRequestDto
 */
export interface UpdateLanguageRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateLanguageRequestDto
     */
    'languageCode': string;
}
/**
 * 
 * @export
 * @interface UpdateModuleNotificationSettingsRequestDto
 */
export interface UpdateModuleNotificationSettingsRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateModuleNotificationSettingsRequestDto
     */
    'emails'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateModuleNotificationSettingsRequestDto
     */
    'emailNotificationsEnabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateModuleNotificationSettingsRequestDto
     */
    'phoneNumbers'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateModuleNotificationSettingsRequestDto
     */
    'smsNotificationsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateModuleNotificationSettingsRequestDto
     */
    'useDefaultNotificationSettings'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateOneDto
 */
export interface UpdateOneDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOneDto
     */
    'type'?: UpdateOneDtoTypeEnum;
    /**
     *
     * @type {boolean}
     * @memberof UpdateOneDto
     */
    'shouldDisplayLiveData'?: boolean;
    /**
     * Admin-only: enable/disable the module.
     * @type {boolean}
     * @memberof UpdateOneDto
     */
    'enabled'?: boolean;
    /**
     * Admin-only: rename the module id.
     * @type {string}
     * @memberof UpdateOneDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOneDto
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOneDto
     */
    'imageKey'?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOneDto
     */
    'serialNumber'?: string;
}

export const UpdateOneDtoTypeEnum = {
    Farmsort: 'FARMSORT',
    Camera: 'CAMERA',
    NotAssigned: 'NOT_ASSIGNED'
} as const;

export type UpdateOneDtoTypeEnum = typeof UpdateOneDtoTypeEnum[keyof typeof UpdateOneDtoTypeEnum];

/**
 * 
 * @export
 * @interface UpdateTranslationDto
 */
export interface UpdateTranslationDto {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof UpdateTranslationDto
     */
    'values': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'languageCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'role'?: UpdateUserDtoRoleEnum;
}

export const UpdateUserDtoRoleEnum = {
    Admin: 'ADMIN',
    Customer: 'CUSTOMER',
    DemoUser: 'DEMO_USER',
    Test: 'TEST'
} as const;

export type UpdateUserDtoRoleEnum = typeof UpdateUserDtoRoleEnum[keyof typeof UpdateUserDtoRoleEnum];

/**
 * 
 * @export
 * @interface VideoJobDto
 */
export interface VideoJobDto {
    /**
     * 
     * @type {string}
     * @memberof VideoJobDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof VideoJobDto
     */
    'moduleId': string;
    /**
     * 
     * @type {string}
     * @memberof VideoJobDto
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof VideoJobDto
     */
    'endTime': string;
    /**
     * 
     * @type {string}
     * @memberof VideoJobDto
     */
    'status': VideoJobDtoStatusEnum;
    /**
     * 
     * @type {object}
     * @memberof VideoJobDto
     */
    'progress'?: object;
    /**
     * 
     * @type {string}
     * @memberof VideoJobDto
     */
    'generatedFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VideoJobDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VideoJobDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof VideoJobDto
     */
    'updatedAt': string;
}

export const VideoJobDtoStatusEnum = {
    Pending: 'PENDING',
    DownloadingVideoSegments: 'DOWNLOADING_VIDEO_SEGMENTS',
    GeneratingConcatFile: 'GENERATING_CONCAT_FILE',
    ProcessingVideoFiles: 'PROCESSING_VIDEO_FILES',
    PushingResultsToS3: 'PUSHING_RESULTS_TO_S3',
    DeletingGeneratedFiles: 'DELETING_GENERATED_FILES',
    Done: 'DONE',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
} as const;

export type VideoJobDtoStatusEnum = typeof VideoJobDtoStatusEnum[keyof typeof VideoJobDtoStatusEnum];


/**
 * AdminAssetsApi - axios parameter creator
 * @export
 */
export const AdminAssetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssetsControllerGetModuleImagePresets: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/assets/module-image-presets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp'} mimeType 
         * @param {string} imageKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssetsControllerGetUploadUrl: async (mimeType: 'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp', imageKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mimeType' is not null or undefined
            assertParamExists('adminAssetsControllerGetUploadUrl', 'mimeType', mimeType)
            // verify required parameter 'imageKey' is not null or undefined
            assertParamExists('adminAssetsControllerGetUploadUrl', 'imageKey', imageKey)
            const localVarPath = `/admin/assets/upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (mimeType !== undefined) {
                localVarQueryParameter['mimeType'] = mimeType;
            }

            if (imageKey !== undefined) {
                localVarQueryParameter['imageKey'] = imageKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAssetsApi - functional programming interface
 * @export
 */
export const AdminAssetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAssetsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAssetsControllerGetModuleImagePresets(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModuleImagePresetDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAssetsControllerGetModuleImagePresets(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp'} mimeType 
         * @param {string} imageKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAssetsControllerGetUploadUrl(mimeType: 'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp', imageKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPresignedUploadUrlResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAssetsControllerGetUploadUrl(mimeType, imageKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminAssetsApi - factory interface
 * @export
 */
export const AdminAssetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAssetsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssetsControllerGetModuleImagePresets(options?: any): AxiosPromise<Array<ModuleImagePresetDto>> {
            return localVarFp.adminAssetsControllerGetModuleImagePresets(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp'} mimeType 
         * @param {string} imageKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssetsControllerGetUploadUrl(mimeType: 'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp', imageKey: string, options?: any): AxiosPromise<GetPresignedUploadUrlResponseDto> {
            return localVarFp.adminAssetsControllerGetUploadUrl(mimeType, imageKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminAssetsApi - object-oriented interface
 * @export
 * @class AdminAssetsApi
 * @extends {BaseAPI}
 */
export class AdminAssetsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAssetsApi
     */
    public adminAssetsControllerGetModuleImagePresets(options?: AxiosRequestConfig) {
        return AdminAssetsApiFp(this.configuration).adminAssetsControllerGetModuleImagePresets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp'} mimeType 
     * @param {string} imageKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAssetsApi
     */
    public adminAssetsControllerGetUploadUrl(mimeType: 'image/apng' | 'image/avif ' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/svg+xml' | 'image/webp', imageKey: string, options?: AxiosRequestConfig) {
        return AdminAssetsApiFp(this.configuration).adminAssetsControllerGetUploadUrl(mimeType, imageKey, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminErrorCodesApi - axios parameter creator
 * @export
 */
export const AdminErrorCodesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {AssignErrorCodeToModuleDto} assignErrorCodeToModuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerAssignToModule: async (id: string, moduleId: string, assignErrorCodeToModuleDto: AssignErrorCodeToModuleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('errorCodesControllerAssignToModule', 'id', id)
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('errorCodesControllerAssignToModule', 'moduleId', moduleId)
            // verify required parameter 'assignErrorCodeToModuleDto' is not null or undefined
            assertParamExists('errorCodesControllerAssignToModule', 'assignErrorCodeToModuleDto', assignErrorCodeToModuleDto)
            const localVarPath = `/admin/error-codes/{id}/modules/{moduleId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"moduleId"}}`, encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignErrorCodeToModuleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateErrorCodeDto} createErrorCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerCreate: async (createErrorCodeDto: CreateErrorCodeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createErrorCodeDto' is not null or undefined
            assertParamExists('errorCodesControllerCreate', 'createErrorCodeDto', createErrorCodeDto)
            const localVarPath = `/admin/error-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createErrorCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('errorCodesControllerDelete', 'id', id)
            const localVarPath = `/admin/error-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerGetOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('errorCodesControllerGetOne', 'id', id)
            const localVarPath = `/admin/error-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerList: async (page?: number, limit?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/error-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerUnassignFromModule: async (id: string, moduleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('errorCodesControllerUnassignFromModule', 'id', id)
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('errorCodesControllerUnassignFromModule', 'moduleId', moduleId)
            const localVarPath = `/admin/error-codes/{id}/modules/{moduleId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"moduleId"}}`, encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateErrorCodeDto} updateErrorCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerUpdate: async (id: string, updateErrorCodeDto: UpdateErrorCodeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('errorCodesControllerUpdate', 'id', id)
            // verify required parameter 'updateErrorCodeDto' is not null or undefined
            assertParamExists('errorCodesControllerUpdate', 'updateErrorCodeDto', updateErrorCodeDto)
            const localVarPath = `/admin/error-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateErrorCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {UpdateErrorCodeAssignmentDto} updateErrorCodeAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerUpdateAssignment: async (id: string, moduleId: string, updateErrorCodeAssignmentDto: UpdateErrorCodeAssignmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('errorCodesControllerUpdateAssignment', 'id', id)
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('errorCodesControllerUpdateAssignment', 'moduleId', moduleId)
            // verify required parameter 'updateErrorCodeAssignmentDto' is not null or undefined
            assertParamExists('errorCodesControllerUpdateAssignment', 'updateErrorCodeAssignmentDto', updateErrorCodeAssignmentDto)
            const localVarPath = `/admin/error-codes/{id}/modules/{moduleId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"moduleId"}}`, encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateErrorCodeAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminErrorCodesApi - functional programming interface
 * @export
 */
export const AdminErrorCodesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminErrorCodesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {AssignErrorCodeToModuleDto} assignErrorCodeToModuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorCodesControllerAssignToModule(id: string, moduleId: string, assignErrorCodeToModuleDto: AssignErrorCodeToModuleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorCodesControllerAssignToModule(id, moduleId, assignErrorCodeToModuleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateErrorCodeDto} createErrorCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorCodesControllerCreate(createErrorCodeDto: CreateErrorCodeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorCodeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorCodesControllerCreate(createErrorCodeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorCodesControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorCodesControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorCodesControllerGetOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorCodeDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorCodesControllerGetOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorCodesControllerList(page?: number, limit?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListErrorCodesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorCodesControllerList(page, limit, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorCodesControllerUnassignFromModule(id: string, moduleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorCodesControllerUnassignFromModule(id, moduleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateErrorCodeDto} updateErrorCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorCodesControllerUpdate(id: string, updateErrorCodeDto: UpdateErrorCodeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorCodeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorCodesControllerUpdate(id, updateErrorCodeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {UpdateErrorCodeAssignmentDto} updateErrorCodeAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorCodesControllerUpdateAssignment(id: string, moduleId: string, updateErrorCodeAssignmentDto: UpdateErrorCodeAssignmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorCodesControllerUpdateAssignment(id, moduleId, updateErrorCodeAssignmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminErrorCodesApi - factory interface
 * @export
 */
export const AdminErrorCodesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminErrorCodesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {AssignErrorCodeToModuleDto} assignErrorCodeToModuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerAssignToModule(id: string, moduleId: string, assignErrorCodeToModuleDto: AssignErrorCodeToModuleDto, options?: any): AxiosPromise<void> {
            return localVarFp.errorCodesControllerAssignToModule(id, moduleId, assignErrorCodeToModuleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateErrorCodeDto} createErrorCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerCreate(createErrorCodeDto: CreateErrorCodeDto, options?: any): AxiosPromise<ErrorCodeDto> {
            return localVarFp.errorCodesControllerCreate(createErrorCodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.errorCodesControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerGetOne(id: string, options?: any): AxiosPromise<ErrorCodeDetailDto> {
            return localVarFp.errorCodesControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerList(page?: number, limit?: number, search?: string, options?: any): AxiosPromise<ListErrorCodesResponseDto> {
            return localVarFp.errorCodesControllerList(page, limit, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerUnassignFromModule(id: string, moduleId: string, options?: any): AxiosPromise<void> {
            return localVarFp.errorCodesControllerUnassignFromModule(id, moduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateErrorCodeDto} updateErrorCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerUpdate(id: string, updateErrorCodeDto: UpdateErrorCodeDto, options?: any): AxiosPromise<ErrorCodeDto> {
            return localVarFp.errorCodesControllerUpdate(id, updateErrorCodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {UpdateErrorCodeAssignmentDto} updateErrorCodeAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorCodesControllerUpdateAssignment(id: string, moduleId: string, updateErrorCodeAssignmentDto: UpdateErrorCodeAssignmentDto, options?: any): AxiosPromise<void> {
            return localVarFp.errorCodesControllerUpdateAssignment(id, moduleId, updateErrorCodeAssignmentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminErrorCodesApi - object-oriented interface
 * @export
 * @class AdminErrorCodesApi
 * @extends {BaseAPI}
 */
export class AdminErrorCodesApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} moduleId 
     * @param {AssignErrorCodeToModuleDto} assignErrorCodeToModuleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminErrorCodesApi
     */
    public errorCodesControllerAssignToModule(id: string, moduleId: string, assignErrorCodeToModuleDto: AssignErrorCodeToModuleDto, options?: AxiosRequestConfig) {
        return AdminErrorCodesApiFp(this.configuration).errorCodesControllerAssignToModule(id, moduleId, assignErrorCodeToModuleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateErrorCodeDto} createErrorCodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminErrorCodesApi
     */
    public errorCodesControllerCreate(createErrorCodeDto: CreateErrorCodeDto, options?: AxiosRequestConfig) {
        return AdminErrorCodesApiFp(this.configuration).errorCodesControllerCreate(createErrorCodeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminErrorCodesApi
     */
    public errorCodesControllerDelete(id: string, options?: AxiosRequestConfig) {
        return AdminErrorCodesApiFp(this.configuration).errorCodesControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminErrorCodesApi
     */
    public errorCodesControllerGetOne(id: string, options?: AxiosRequestConfig) {
        return AdminErrorCodesApiFp(this.configuration).errorCodesControllerGetOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] current page
     * @param {number} [limit] rows per page
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminErrorCodesApi
     */
    public errorCodesControllerList(page?: number, limit?: number, search?: string, options?: AxiosRequestConfig) {
        return AdminErrorCodesApiFp(this.configuration).errorCodesControllerList(page, limit, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} moduleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminErrorCodesApi
     */
    public errorCodesControllerUnassignFromModule(id: string, moduleId: string, options?: AxiosRequestConfig) {
        return AdminErrorCodesApiFp(this.configuration).errorCodesControllerUnassignFromModule(id, moduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateErrorCodeDto} updateErrorCodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminErrorCodesApi
     */
    public errorCodesControllerUpdate(id: string, updateErrorCodeDto: UpdateErrorCodeDto, options?: AxiosRequestConfig) {
        return AdminErrorCodesApiFp(this.configuration).errorCodesControllerUpdate(id, updateErrorCodeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} moduleId 
     * @param {UpdateErrorCodeAssignmentDto} updateErrorCodeAssignmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminErrorCodesApi
     */
    public errorCodesControllerUpdateAssignment(id: string, moduleId: string, updateErrorCodeAssignmentDto: UpdateErrorCodeAssignmentDto, options?: AxiosRequestConfig) {
        return AdminErrorCodesApiFp(this.configuration).errorCodesControllerUpdateAssignment(id, moduleId, updateErrorCodeAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminFeatureFlagsApi - axios parameter creator
 * @export
 */
export const AdminFeatureFlagsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {AssignFeatureFlagDto} assignFeatureFlagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerAssignModule: async (id: string, moduleId: string, assignFeatureFlagDto: AssignFeatureFlagDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerAssignModule', 'id', id)
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('featureFlagsControllerAssignModule', 'moduleId', moduleId)
            // verify required parameter 'assignFeatureFlagDto' is not null or undefined
            assertParamExists('featureFlagsControllerAssignModule', 'assignFeatureFlagDto', assignFeatureFlagDto)
            const localVarPath = `/admin/feature-flags/{id}/modules/{moduleId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"moduleId"}}`, encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignFeatureFlagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userId 
         * @param {AssignFeatureFlagDto} assignFeatureFlagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerAssignUser: async (id: string, userId: string, assignFeatureFlagDto: AssignFeatureFlagDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerAssignUser', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('featureFlagsControllerAssignUser', 'userId', userId)
            // verify required parameter 'assignFeatureFlagDto' is not null or undefined
            assertParamExists('featureFlagsControllerAssignUser', 'assignFeatureFlagDto', assignFeatureFlagDto)
            const localVarPath = `/admin/feature-flags/{id}/users/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignFeatureFlagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateFeatureFlagDto} createFeatureFlagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerCreate: async (createFeatureFlagDto: CreateFeatureFlagDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFeatureFlagDto' is not null or undefined
            assertParamExists('featureFlagsControllerCreate', 'createFeatureFlagDto', createFeatureFlagDto)
            const localVarPath = `/admin/feature-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFeatureFlagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerDelete', 'id', id)
            const localVarPath = `/admin/feature-flags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {'createdAt' | 'enabled' | 'name'} [sortBy] 
         * @param {'asc' | 'desc'} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerFindAll: async (page?: number, limit?: number, sortBy?: 'createdAt' | 'enabled' | 'name', sortOrder?: 'asc' | 'desc', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/feature-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerFindOne', 'id', id)
            const localVarPath = `/admin/feature-flags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerUnassignModule: async (id: string, moduleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerUnassignModule', 'id', id)
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('featureFlagsControllerUnassignModule', 'moduleId', moduleId)
            const localVarPath = `/admin/feature-flags/{id}/modules/{moduleId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"moduleId"}}`, encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerUnassignUser: async (id: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerUnassignUser', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('featureFlagsControllerUnassignUser', 'userId', userId)
            const localVarPath = `/admin/feature-flags/{id}/users/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {UpdateFeatureFlagAssignmentDto} updateFeatureFlagAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerUpdateModuleAssignment: async (id: string, moduleId: string, updateFeatureFlagAssignmentDto: UpdateFeatureFlagAssignmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerUpdateModuleAssignment', 'id', id)
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('featureFlagsControllerUpdateModuleAssignment', 'moduleId', moduleId)
            // verify required parameter 'updateFeatureFlagAssignmentDto' is not null or undefined
            assertParamExists('featureFlagsControllerUpdateModuleAssignment', 'updateFeatureFlagAssignmentDto', updateFeatureFlagAssignmentDto)
            const localVarPath = `/admin/feature-flags/{id}/modules/{moduleId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"moduleId"}}`, encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeatureFlagAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateFeatureFlagDto} updateFeatureFlagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerUpdateOne: async (id: string, updateFeatureFlagDto: UpdateFeatureFlagDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerUpdateOne', 'id', id)
            // verify required parameter 'updateFeatureFlagDto' is not null or undefined
            assertParamExists('featureFlagsControllerUpdateOne', 'updateFeatureFlagDto', updateFeatureFlagDto)
            const localVarPath = `/admin/feature-flags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeatureFlagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userId 
         * @param {UpdateFeatureFlagAssignmentDto} updateFeatureFlagAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerUpdateUserAssignment: async (id: string, userId: string, updateFeatureFlagAssignmentDto: UpdateFeatureFlagAssignmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerUpdateUserAssignment', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('featureFlagsControllerUpdateUserAssignment', 'userId', userId)
            // verify required parameter 'updateFeatureFlagAssignmentDto' is not null or undefined
            assertParamExists('featureFlagsControllerUpdateUserAssignment', 'updateFeatureFlagAssignmentDto', updateFeatureFlagAssignmentDto)
            const localVarPath = `/admin/feature-flags/{id}/users/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeatureFlagAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFeatureFlagsApi - functional programming interface
 * @export
 */
export const AdminFeatureFlagsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFeatureFlagsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {AssignFeatureFlagDto} assignFeatureFlagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerAssignModule(id: string, moduleId: string, assignFeatureFlagDto: AssignFeatureFlagDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerAssignModule(id, moduleId, assignFeatureFlagDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userId 
         * @param {AssignFeatureFlagDto} assignFeatureFlagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerAssignUser(id: string, userId: string, assignFeatureFlagDto: AssignFeatureFlagDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerAssignUser(id, userId, assignFeatureFlagDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateFeatureFlagDto} createFeatureFlagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerCreate(createFeatureFlagDto: CreateFeatureFlagDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureFlagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerCreate(createFeatureFlagDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {'createdAt' | 'enabled' | 'name'} [sortBy] 
         * @param {'asc' | 'desc'} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerFindAll(page?: number, limit?: number, sortBy?: 'createdAt' | 'enabled' | 'name', sortOrder?: 'asc' | 'desc', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListFeatureFlagsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerFindAll(page, limit, sortBy, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureFlagDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerFindOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerUnassignModule(id: string, moduleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerUnassignModule(id, moduleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerUnassignUser(id: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerUnassignUser(id, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {UpdateFeatureFlagAssignmentDto} updateFeatureFlagAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerUpdateModuleAssignment(id: string, moduleId: string, updateFeatureFlagAssignmentDto: UpdateFeatureFlagAssignmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerUpdateModuleAssignment(id, moduleId, updateFeatureFlagAssignmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateFeatureFlagDto} updateFeatureFlagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerUpdateOne(id: string, updateFeatureFlagDto: UpdateFeatureFlagDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureFlagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerUpdateOne(id, updateFeatureFlagDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userId 
         * @param {UpdateFeatureFlagAssignmentDto} updateFeatureFlagAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerUpdateUserAssignment(id: string, userId: string, updateFeatureFlagAssignmentDto: UpdateFeatureFlagAssignmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerUpdateUserAssignment(id, userId, updateFeatureFlagAssignmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminFeatureFlagsApi - factory interface
 * @export
 */
export const AdminFeatureFlagsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFeatureFlagsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {AssignFeatureFlagDto} assignFeatureFlagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerAssignModule(id: string, moduleId: string, assignFeatureFlagDto: AssignFeatureFlagDto, options?: any): AxiosPromise<void> {
            return localVarFp.featureFlagsControllerAssignModule(id, moduleId, assignFeatureFlagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userId 
         * @param {AssignFeatureFlagDto} assignFeatureFlagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerAssignUser(id: string, userId: string, assignFeatureFlagDto: AssignFeatureFlagDto, options?: any): AxiosPromise<void> {
            return localVarFp.featureFlagsControllerAssignUser(id, userId, assignFeatureFlagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateFeatureFlagDto} createFeatureFlagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerCreate(createFeatureFlagDto: CreateFeatureFlagDto, options?: any): AxiosPromise<FeatureFlagDto> {
            return localVarFp.featureFlagsControllerCreate(createFeatureFlagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.featureFlagsControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {'createdAt' | 'enabled' | 'name'} [sortBy] 
         * @param {'asc' | 'desc'} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerFindAll(page?: number, limit?: number, sortBy?: 'createdAt' | 'enabled' | 'name', sortOrder?: 'asc' | 'desc', options?: any): AxiosPromise<ListFeatureFlagsResponseDto> {
            return localVarFp.featureFlagsControllerFindAll(page, limit, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerFindOne(id: string, options?: any): AxiosPromise<FeatureFlagDetailDto> {
            return localVarFp.featureFlagsControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerUnassignModule(id: string, moduleId: string, options?: any): AxiosPromise<void> {
            return localVarFp.featureFlagsControllerUnassignModule(id, moduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerUnassignUser(id: string, userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.featureFlagsControllerUnassignUser(id, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {UpdateFeatureFlagAssignmentDto} updateFeatureFlagAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerUpdateModuleAssignment(id: string, moduleId: string, updateFeatureFlagAssignmentDto: UpdateFeatureFlagAssignmentDto, options?: any): AxiosPromise<void> {
            return localVarFp.featureFlagsControllerUpdateModuleAssignment(id, moduleId, updateFeatureFlagAssignmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateFeatureFlagDto} updateFeatureFlagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerUpdateOne(id: string, updateFeatureFlagDto: UpdateFeatureFlagDto, options?: any): AxiosPromise<FeatureFlagDto> {
            return localVarFp.featureFlagsControllerUpdateOne(id, updateFeatureFlagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userId 
         * @param {UpdateFeatureFlagAssignmentDto} updateFeatureFlagAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerUpdateUserAssignment(id: string, userId: string, updateFeatureFlagAssignmentDto: UpdateFeatureFlagAssignmentDto, options?: any): AxiosPromise<void> {
            return localVarFp.featureFlagsControllerUpdateUserAssignment(id, userId, updateFeatureFlagAssignmentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminFeatureFlagsApi - object-oriented interface
 * @export
 * @class AdminFeatureFlagsApi
 * @extends {BaseAPI}
 */
export class AdminFeatureFlagsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} moduleId 
     * @param {AssignFeatureFlagDto} assignFeatureFlagDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeatureFlagsApi
     */
    public featureFlagsControllerAssignModule(id: string, moduleId: string, assignFeatureFlagDto: AssignFeatureFlagDto, options?: AxiosRequestConfig) {
        return AdminFeatureFlagsApiFp(this.configuration).featureFlagsControllerAssignModule(id, moduleId, assignFeatureFlagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} userId 
     * @param {AssignFeatureFlagDto} assignFeatureFlagDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeatureFlagsApi
     */
    public featureFlagsControllerAssignUser(id: string, userId: string, assignFeatureFlagDto: AssignFeatureFlagDto, options?: AxiosRequestConfig) {
        return AdminFeatureFlagsApiFp(this.configuration).featureFlagsControllerAssignUser(id, userId, assignFeatureFlagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateFeatureFlagDto} createFeatureFlagDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeatureFlagsApi
     */
    public featureFlagsControllerCreate(createFeatureFlagDto: CreateFeatureFlagDto, options?: AxiosRequestConfig) {
        return AdminFeatureFlagsApiFp(this.configuration).featureFlagsControllerCreate(createFeatureFlagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeatureFlagsApi
     */
    public featureFlagsControllerDelete(id: string, options?: AxiosRequestConfig) {
        return AdminFeatureFlagsApiFp(this.configuration).featureFlagsControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] current page
     * @param {number} [limit] rows per page
     * @param {'createdAt' | 'enabled' | 'name'} [sortBy] 
     * @param {'asc' | 'desc'} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeatureFlagsApi
     */
    public featureFlagsControllerFindAll(page?: number, limit?: number, sortBy?: 'createdAt' | 'enabled' | 'name', sortOrder?: 'asc' | 'desc', options?: AxiosRequestConfig) {
        return AdminFeatureFlagsApiFp(this.configuration).featureFlagsControllerFindAll(page, limit, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeatureFlagsApi
     */
    public featureFlagsControllerFindOne(id: string, options?: AxiosRequestConfig) {
        return AdminFeatureFlagsApiFp(this.configuration).featureFlagsControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} moduleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeatureFlagsApi
     */
    public featureFlagsControllerUnassignModule(id: string, moduleId: string, options?: AxiosRequestConfig) {
        return AdminFeatureFlagsApiFp(this.configuration).featureFlagsControllerUnassignModule(id, moduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeatureFlagsApi
     */
    public featureFlagsControllerUnassignUser(id: string, userId: string, options?: AxiosRequestConfig) {
        return AdminFeatureFlagsApiFp(this.configuration).featureFlagsControllerUnassignUser(id, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} moduleId 
     * @param {UpdateFeatureFlagAssignmentDto} updateFeatureFlagAssignmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeatureFlagsApi
     */
    public featureFlagsControllerUpdateModuleAssignment(id: string, moduleId: string, updateFeatureFlagAssignmentDto: UpdateFeatureFlagAssignmentDto, options?: AxiosRequestConfig) {
        return AdminFeatureFlagsApiFp(this.configuration).featureFlagsControllerUpdateModuleAssignment(id, moduleId, updateFeatureFlagAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateFeatureFlagDto} updateFeatureFlagDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeatureFlagsApi
     */
    public featureFlagsControllerUpdateOne(id: string, updateFeatureFlagDto: UpdateFeatureFlagDto, options?: AxiosRequestConfig) {
        return AdminFeatureFlagsApiFp(this.configuration).featureFlagsControllerUpdateOne(id, updateFeatureFlagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} userId 
     * @param {UpdateFeatureFlagAssignmentDto} updateFeatureFlagAssignmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeatureFlagsApi
     */
    public featureFlagsControllerUpdateUserAssignment(id: string, userId: string, updateFeatureFlagAssignmentDto: UpdateFeatureFlagAssignmentDto, options?: AxiosRequestConfig) {
        return AdminFeatureFlagsApiFp(this.configuration).featureFlagsControllerUpdateUserAssignment(id, userId, updateFeatureFlagAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminModuleRunsApi - axios parameter creator
 * @export
 */
export const AdminModuleRunsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AggregateModuleRunsRequestDto} aggregateModuleRunsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerAggregate: async (aggregateModuleRunsRequestDto: AggregateModuleRunsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateModuleRunsRequestDto' is not null or undefined
            assertParamExists('moduleRunsControllerAggregate', 'aggregateModuleRunsRequestDto', aggregateModuleRunsRequestDto)
            const localVarPath = `/admin/module-runs/aggregate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aggregateModuleRunsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ListModuleRunsRequestDto} listModuleRunsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerFindAll: async (listModuleRunsRequestDto: ListModuleRunsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listModuleRunsRequestDto' is not null or undefined
            assertParamExists('moduleRunsControllerFindAll', 'listModuleRunsRequestDto', listModuleRunsRequestDto)
            const localVarPath = `/admin/module-runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listModuleRunsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerFindChartDataForRunId: async (runId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('moduleRunsControllerFindChartDataForRunId', 'runId', runId)
            const localVarPath = `/admin/module-runs/chart-data/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moduleRunsControllerFindOne', 'id', id)
            const localVarPath = `/admin/module-runs/by-module-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerGetRunMetricsTotalsForPeriods: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/module-runs/run-metrics-totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminModuleRunsApi - functional programming interface
 * @export
 */
export const AdminModuleRunsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminModuleRunsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AggregateModuleRunsRequestDto} aggregateModuleRunsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleRunsControllerAggregate(aggregateModuleRunsRequestDto: AggregateModuleRunsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregateModuleRunsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleRunsControllerAggregate(aggregateModuleRunsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ListModuleRunsRequestDto} listModuleRunsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleRunsControllerFindAll(listModuleRunsRequestDto: ListModuleRunsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListModuleRunsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleRunsControllerFindAll(listModuleRunsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleRunsControllerFindChartDataForRunId(runId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindChartDataForRunIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleRunsControllerFindChartDataForRunId(runId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleRunsControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AugmentedModuleRunDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleRunsControllerFindOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleRunsControllerGetRunMetricsTotalsForPeriods(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregateModuleRunMetricTotalsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleRunsControllerGetRunMetricsTotalsForPeriods(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminModuleRunsApi - factory interface
 * @export
 */
export const AdminModuleRunsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminModuleRunsApiFp(configuration)
    return {
        /**
         * 
         * @param {AggregateModuleRunsRequestDto} aggregateModuleRunsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerAggregate(aggregateModuleRunsRequestDto: AggregateModuleRunsRequestDto, options?: any): AxiosPromise<AggregateModuleRunsResponseDto> {
            return localVarFp.moduleRunsControllerAggregate(aggregateModuleRunsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ListModuleRunsRequestDto} listModuleRunsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerFindAll(listModuleRunsRequestDto: ListModuleRunsRequestDto, options?: any): AxiosPromise<ListModuleRunsResponseDto> {
            return localVarFp.moduleRunsControllerFindAll(listModuleRunsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerFindChartDataForRunId(runId: string, options?: any): AxiosPromise<FindChartDataForRunIdDto> {
            return localVarFp.moduleRunsControllerFindChartDataForRunId(runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerFindOne(id: string, options?: any): AxiosPromise<AugmentedModuleRunDto> {
            return localVarFp.moduleRunsControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleRunsControllerGetRunMetricsTotalsForPeriods(options?: any): AxiosPromise<AggregateModuleRunMetricTotalsResponseDto> {
            return localVarFp.moduleRunsControllerGetRunMetricsTotalsForPeriods(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminModuleRunsApi - object-oriented interface
 * @export
 * @class AdminModuleRunsApi
 * @extends {BaseAPI}
 */
export class AdminModuleRunsApi extends BaseAPI {
    /**
     * 
     * @param {AggregateModuleRunsRequestDto} aggregateModuleRunsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModuleRunsApi
     */
    public moduleRunsControllerAggregate(aggregateModuleRunsRequestDto: AggregateModuleRunsRequestDto, options?: AxiosRequestConfig) {
        return AdminModuleRunsApiFp(this.configuration).moduleRunsControllerAggregate(aggregateModuleRunsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ListModuleRunsRequestDto} listModuleRunsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModuleRunsApi
     */
    public moduleRunsControllerFindAll(listModuleRunsRequestDto: ListModuleRunsRequestDto, options?: AxiosRequestConfig) {
        return AdminModuleRunsApiFp(this.configuration).moduleRunsControllerFindAll(listModuleRunsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} runId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModuleRunsApi
     */
    public moduleRunsControllerFindChartDataForRunId(runId: string, options?: AxiosRequestConfig) {
        return AdminModuleRunsApiFp(this.configuration).moduleRunsControllerFindChartDataForRunId(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModuleRunsApi
     */
    public moduleRunsControllerFindOne(id: string, options?: AxiosRequestConfig) {
        return AdminModuleRunsApiFp(this.configuration).moduleRunsControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModuleRunsApi
     */
    public moduleRunsControllerGetRunMetricsTotalsForPeriods(options?: AxiosRequestConfig) {
        return AdminModuleRunsApiFp(this.configuration).moduleRunsControllerGetRunMetricsTotalsForPeriods(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminModulesApi - axios parameter creator
 * @export
 */
export const AdminModulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateModuleDto} createModuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerCreate: async (createModuleDto: CreateModuleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createModuleDto' is not null or undefined
            assertParamExists('adminModulesControllerCreate', 'createModuleDto', createModuleDto)
            const localVarPath = `/admin/modules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createModuleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminModulesControllerDelete', 'id', id)
            const localVarPath = `/admin/modules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {'on' | 'off'} [status] 
         * @param {'createdAt' | 'id' | 'name' | 'type'} [sortBy] 
         * @param {'asc' | 'desc'} [sortOrder] 
         * @param {boolean} [onlyFarmsorts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerFindAll: async (page?: number, limit?: number, status?: 'on' | 'off', sortBy?: 'createdAt' | 'id' | 'name' | 'type', sortOrder?: 'asc' | 'desc', onlyFarmsorts?: boolean, search?: string, includeDisabled?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/modules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (onlyFarmsorts !== undefined) {
                localVarQueryParameter['onlyFarmsorts'] = onlyFarmsorts;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (includeDisabled !== undefined) {
                localVarQueryParameter['includeDisabled'] = includeDisabled;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminModulesControllerFindOne', 'id', id)
            const localVarPath = `/admin/modules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateOneDto} updateOneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerUpdateOne: async (id: string, updateOneDto: UpdateOneDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminModulesControllerUpdateOne', 'id', id)
            // verify required parameter 'updateOneDto' is not null or undefined
            assertParamExists('adminModulesControllerUpdateOne', 'updateOneDto', updateOneDto)
            const localVarPath = `/admin/modules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOneDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminModulesApi - functional programming interface
 * @export
 */
export const AdminModulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminModulesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateModuleDto} createModuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminModulesControllerCreate(createModuleDto: CreateModuleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminModulesControllerCreate(createModuleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminModulesControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminModulesControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {'on' | 'off'} [status] 
         * @param {'createdAt' | 'id' | 'name' | 'type'} [sortBy] 
         * @param {'asc' | 'desc'} [sortOrder] 
         * @param {boolean} [onlyFarmsorts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminModulesControllerFindAll(page?: number, limit?: number, status?: 'on' | 'off', sortBy?: 'createdAt' | 'id' | 'name' | 'type', sortOrder?: 'asc' | 'desc', onlyFarmsorts?: boolean, search?: string, includeDisabled?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListModulesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminModulesControllerFindAll(page, limit, status, sortBy, sortOrder, onlyFarmsorts, search, includeDisabled, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminModulesControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminModulesControllerFindOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateOneDto} updateOneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminModulesControllerUpdateOne(id: string, updateOneDto: UpdateOneDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminModulesControllerUpdateOne(id, updateOneDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminModulesApi - factory interface
 * @export
 */
export const AdminModulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminModulesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateModuleDto} createModuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerCreate(createModuleDto: CreateModuleDto, options?: any): AxiosPromise<ModuleDto> {
            return localVarFp.adminModulesControllerCreate(createModuleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminModulesControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {'on' | 'off'} [status] 
         * @param {'createdAt' | 'id' | 'name' | 'type'} [sortBy] 
         * @param {'asc' | 'desc'} [sortOrder] 
         * @param {boolean} [onlyFarmsorts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerFindAll(page?: number, limit?: number, status?: 'on' | 'off', sortBy?: 'createdAt' | 'id' | 'name' | 'type', sortOrder?: 'asc' | 'desc', onlyFarmsorts?: boolean, search?: string, includeDisabled?: boolean, options?: any): AxiosPromise<ListModulesResponseDto> {
            return localVarFp.adminModulesControllerFindAll(page, limit, status, sortBy, sortOrder, onlyFarmsorts, search, includeDisabled, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerFindOne(id: string, options?: any): AxiosPromise<ModuleDto> {
            return localVarFp.adminModulesControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateOneDto} updateOneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModulesControllerUpdateOne(id: string, updateOneDto: UpdateOneDto, options?: any): AxiosPromise<ModuleDto> {
            return localVarFp.adminModulesControllerUpdateOne(id, updateOneDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminModulesApi - object-oriented interface
 * @export
 * @class AdminModulesApi
 * @extends {BaseAPI}
 */
export class AdminModulesApi extends BaseAPI {
    /**
     * 
     * @param {CreateModuleDto} createModuleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModulesApi
     */
    public adminModulesControllerCreate(createModuleDto: CreateModuleDto, options?: AxiosRequestConfig) {
        return AdminModulesApiFp(this.configuration).adminModulesControllerCreate(createModuleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModulesApi
     */
    public adminModulesControllerDelete(id: string, options?: AxiosRequestConfig) {
        return AdminModulesApiFp(this.configuration).adminModulesControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] current page
     * @param {number} [limit] rows per page
     * @param {'on' | 'off'} [status] 
     * @param {'createdAt' | 'id' | 'name' | 'type'} [sortBy] 
     * @param {'asc' | 'desc'} [sortOrder] 
     * @param {boolean} [onlyFarmsorts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModulesApi
     */
    public adminModulesControllerFindAll(page?: number, limit?: number, status?: 'on' | 'off', sortBy?: 'createdAt' | 'id' | 'name' | 'type', sortOrder?: 'asc' | 'desc', onlyFarmsorts?: boolean, search?: string, includeDisabled?: boolean, options?: AxiosRequestConfig) {
        return AdminModulesApiFp(this.configuration).adminModulesControllerFindAll(page, limit, status, sortBy, sortOrder, onlyFarmsorts, search, includeDisabled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModulesApi
     */
    public adminModulesControllerFindOne(id: string, options?: AxiosRequestConfig) {
        return AdminModulesApiFp(this.configuration).adminModulesControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateOneDto} updateOneDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminModulesApi
     */
    public adminModulesControllerUpdateOne(id: string, updateOneDto: UpdateOneDto, options?: AxiosRequestConfig) {
        return AdminModulesApiFp(this.configuration).adminModulesControllerUpdateOne(id, updateOneDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminNotificationLogApi - axios parameter creator
 * @export
 */
export const AdminNotificationLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {string} [moduleId] 
         * @param {'SMS' | 'EMAIL'} [channel] 
         * @param {string} [notificationType] 
         * @param {'SUCCESS' | 'FAILED'} [status] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {'sentAt' | 'channel' | 'status' | 'notificationType'} [sortBy] 
         * @param {'asc' | 'desc'} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationLogControllerList: async (page?: number, limit?: number, moduleId?: string, channel?: 'SMS' | 'EMAIL' | 'PUSH', notificationType?: string, status?: 'SUCCESS' | 'FAILED', dateFrom?: string, dateTo?: string, sortBy?: 'sentAt' | 'channel' | 'status' | 'notificationType', sortOrder?: 'asc' | 'desc', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/notification-log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (moduleId !== undefined) {
                localVarQueryParameter['moduleId'] = moduleId;
            }

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }

            if (notificationType !== undefined) {
                localVarQueryParameter['notificationType'] = notificationType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminNotificationLogApi - functional programming interface
 * @export
 */
export const AdminNotificationLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminNotificationLogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {string} [moduleId] 
         * @param {'SMS' | 'EMAIL'} [channel] 
         * @param {string} [notificationType] 
         * @param {'SUCCESS' | 'FAILED'} [status] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {'sentAt' | 'channel' | 'status' | 'notificationType'} [sortBy] 
         * @param {'asc' | 'desc'} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationLogControllerList(page?: number, limit?: number, moduleId?: string, channel?: 'SMS' | 'EMAIL' | 'PUSH', notificationType?: string, status?: 'SUCCESS' | 'FAILED', dateFrom?: string, dateTo?: string, sortBy?: 'sentAt' | 'channel' | 'status' | 'notificationType', sortOrder?: 'asc' | 'desc', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNotificationLogResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationLogControllerList(page, limit, moduleId, channel, notificationType, status, dateFrom, dateTo, sortBy, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminNotificationLogApi - factory interface
 * @export
 */
export const AdminNotificationLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminNotificationLogApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {string} [moduleId] 
         * @param {'SMS' | 'EMAIL'} [channel] 
         * @param {string} [notificationType] 
         * @param {'SUCCESS' | 'FAILED'} [status] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {'sentAt' | 'channel' | 'status' | 'notificationType'} [sortBy] 
         * @param {'asc' | 'desc'} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationLogControllerList(page?: number, limit?: number, moduleId?: string, channel?: 'SMS' | 'EMAIL' | 'PUSH', notificationType?: string, status?: 'SUCCESS' | 'FAILED', dateFrom?: string, dateTo?: string, sortBy?: 'sentAt' | 'channel' | 'status' | 'notificationType', sortOrder?: 'asc' | 'desc', options?: any): AxiosPromise<ListNotificationLogResponseDto> {
            return localVarFp.notificationLogControllerList(page, limit, moduleId, channel, notificationType, status, dateFrom, dateTo, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminNotificationLogApi - object-oriented interface
 * @export
 * @class AdminNotificationLogApi
 * @extends {BaseAPI}
 */
export class AdminNotificationLogApi extends BaseAPI {
    /**
     * 
     * @param {number} [page] current page
     * @param {number} [limit] rows per page
     * @param {string} [moduleId] 
     * @param {'SMS' | 'EMAIL'} [channel] 
     * @param {string} [notificationType] 
     * @param {'SUCCESS' | 'FAILED'} [status] 
     * @param {string} [dateFrom] 
     * @param {string} [dateTo] 
     * @param {'sentAt' | 'channel' | 'status' | 'notificationType'} [sortBy] 
     * @param {'asc' | 'desc'} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationLogApi
     */
    public notificationLogControllerList(page?: number, limit?: number, moduleId?: string, channel?: 'SMS' | 'EMAIL' | 'PUSH', notificationType?: string, status?: 'SUCCESS' | 'FAILED', dateFrom?: string, dateTo?: string, sortBy?: 'sentAt' | 'channel' | 'status' | 'notificationType', sortOrder?: 'asc' | 'desc', options?: AxiosRequestConfig) {
        return AdminNotificationLogApiFp(this.configuration).notificationLogControllerList(page, limit, moduleId, channel, notificationType, status, dateFrom, dateTo, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminNotificationSettingsApi - axios parameter creator
 * @export
 */
export const AdminNotificationSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerFindDefaultNotificationSettings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/notifications-settings/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerGetThresholdSettings: async (moduleId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/notifications-settings/modules/thresholdsettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (moduleId !== undefined) {
                localVarQueryParameter['moduleId'] = moduleId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerListModulesNotificationSettings: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/notifications-settings/modules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} thresholdSettingId 
         * @param {PatchThresholdSettingsRequestDto} patchThresholdSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerPatchThresholdSettings: async (thresholdSettingId: string, patchThresholdSettingsRequestDto: PatchThresholdSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thresholdSettingId' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerPatchThresholdSettings', 'thresholdSettingId', thresholdSettingId)
            // verify required parameter 'patchThresholdSettingsRequestDto' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerPatchThresholdSettings', 'patchThresholdSettingsRequestDto', patchThresholdSettingsRequestDto)
            const localVarPath = `/admin/notifications-settings/modules/thresholdsettings/{thresholdSettingId}`
                .replace(`{${"thresholdSettingId"}}`, encodeURIComponent(String(thresholdSettingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchThresholdSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {IntervallNotificationSettingsRequestDto} intervallNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerSetNotificationInterval: async (moduleNotificationSettingsId: string, intervallNotificationSettingsRequestDto: IntervallNotificationSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleNotificationSettingsId' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerSetNotificationInterval', 'moduleNotificationSettingsId', moduleNotificationSettingsId)
            // verify required parameter 'intervallNotificationSettingsRequestDto' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerSetNotificationInterval', 'intervallNotificationSettingsRequestDto', intervallNotificationSettingsRequestDto)
            const localVarPath = `/admin/notifications-settings/modules/notificationsettings/set-notification-interval/{moduleNotificationSettingsId}`
                .replace(`{${"moduleNotificationSettingsId"}}`, encodeURIComponent(String(moduleNotificationSettingsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(intervallNotificationSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} flowControlSensorAssignmentId
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerToggleModuleNotificationSettingsForFlowControlSensor: async (flowControlSensorAssignmentId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowControlSensorAssignmentId' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerToggleModuleNotificationSettingsForFlowControlSensor', 'flowControlSensorAssignmentId', flowControlSensorAssignmentId)
            // verify required parameter 'toggleModuleNotificationSettingsRequestDto' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerToggleModuleNotificationSettingsForFlowControlSensor', 'toggleModuleNotificationSettingsRequestDto', toggleModuleNotificationSettingsRequestDto)
            const localVarPath = `/admin/notifications-settings/modules/notificationsettings/flow-control/sensors/toggle/{flowControlSensorAssignmentId}`
                .replace(`{${"flowControlSensorAssignmentId"}}`, encodeURIComponent(String(flowControlSensorAssignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleModuleNotificationSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} moduleNotificationSettingsId
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerToggleModuleNotificationSettings: async (moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleNotificationSettingsId' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerToggleModuleNotificationSettings', 'moduleNotificationSettingsId', moduleNotificationSettingsId)
            // verify required parameter 'toggleModuleNotificationSettingsRequestDto' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerToggleModuleNotificationSettings', 'toggleModuleNotificationSettingsRequestDto', toggleModuleNotificationSettingsRequestDto)
            const localVarPath = `/admin/notifications-settings/modules/notificationsettings/toggle/{moduleNotificationSettingsId}`
                .replace(`{${"moduleNotificationSettingsId"}}`, encodeURIComponent(String(moduleNotificationSettingsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleModuleNotificationSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors: async (moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleNotificationSettingsId' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors', 'moduleNotificationSettingsId', moduleNotificationSettingsId)
            // verify required parameter 'toggleModuleNotificationSettingsRequestDto' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors', 'toggleModuleNotificationSettingsRequestDto', toggleModuleNotificationSettingsRequestDto)
            const localVarPath = `/admin/notifications-settings/modules/notificationsettings/errors/toggle/{moduleNotificationSettingsId}`
                .replace(`{${"moduleNotificationSettingsId"}}`, encodeURIComponent(String(moduleNotificationSettingsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleModuleNotificationSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDefaultNotificationSettingsRequestDto} updateDefaultNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerUpdateDefaultNotificationSettings: async (updateDefaultNotificationSettingsRequestDto: UpdateDefaultNotificationSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateDefaultNotificationSettingsRequestDto' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerUpdateDefaultNotificationSettings', 'updateDefaultNotificationSettingsRequestDto', updateDefaultNotificationSettingsRequestDto)
            const localVarPath = `/admin/notifications-settings/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDefaultNotificationSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {UpdateModuleNotificationSettingsRequestDto} updateModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerUpdateModule: async (moduleNotificationSettingsId: string, updateModuleNotificationSettingsRequestDto: UpdateModuleNotificationSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleNotificationSettingsId' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerUpdateModule', 'moduleNotificationSettingsId', moduleNotificationSettingsId)
            // verify required parameter 'updateModuleNotificationSettingsRequestDto' is not null or undefined
            assertParamExists('adminNotificationSettingsControllerUpdateModule', 'updateModuleNotificationSettingsRequestDto', updateModuleNotificationSettingsRequestDto)
            const localVarPath = `/admin/notifications-settings/modules/{moduleNotificationSettingsId}`
                .replace(`{${"moduleNotificationSettingsId"}}`, encodeURIComponent(String(moduleNotificationSettingsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateModuleNotificationSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminNotificationSettingsApi - functional programming interface
 * @export
 */
export const AdminNotificationSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminNotificationSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerFindDefaultNotificationSettings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultNotificationSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerFindDefaultNotificationSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerGetThresholdSettings(moduleId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThresholdSettingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerGetThresholdSettings(moduleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerListModulesNotificationSettings(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListModuleNotificationSettingsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerListModulesNotificationSettings(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} thresholdSettingId 
         * @param {PatchThresholdSettingsRequestDto} patchThresholdSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerPatchThresholdSettings(thresholdSettingId: string, patchThresholdSettingsRequestDto: PatchThresholdSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerPatchThresholdSettings(thresholdSettingId, patchThresholdSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {IntervallNotificationSettingsRequestDto} intervallNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerSetNotificationInterval(moduleNotificationSettingsId: string, intervallNotificationSettingsRequestDto: IntervallNotificationSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerSetNotificationInterval(moduleNotificationSettingsId, intervallNotificationSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerToggleModuleNotificationSettings(moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerToggleModuleNotificationSettings(moduleNotificationSettingsId, toggleModuleNotificationSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} flowControlSensorAssignmentId
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerToggleModuleNotificationSettingsForFlowControlSensor(flowControlSensorAssignmentId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerToggleModuleNotificationSettingsForFlowControlSensor(flowControlSensorAssignmentId, toggleModuleNotificationSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors(moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors(moduleNotificationSettingsId, toggleModuleNotificationSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateDefaultNotificationSettingsRequestDto} updateDefaultNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerUpdateDefaultNotificationSettings(updateDefaultNotificationSettingsRequestDto: UpdateDefaultNotificationSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultNotificationSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerUpdateDefaultNotificationSettings(updateDefaultNotificationSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {UpdateModuleNotificationSettingsRequestDto} updateModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationSettingsControllerUpdateModule(moduleNotificationSettingsId: string, updateModuleNotificationSettingsRequestDto: UpdateModuleNotificationSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleNotificationSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationSettingsControllerUpdateModule(moduleNotificationSettingsId, updateModuleNotificationSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminNotificationSettingsApi - factory interface
 * @export
 */
export const AdminNotificationSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminNotificationSettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerFindDefaultNotificationSettings(options?: any): AxiosPromise<DefaultNotificationSettingsDto> {
            return localVarFp.adminNotificationSettingsControllerFindDefaultNotificationSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerGetThresholdSettings(moduleId?: string, options?: any): AxiosPromise<ThresholdSettingDto> {
            return localVarFp.adminNotificationSettingsControllerGetThresholdSettings(moduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerListModulesNotificationSettings(page?: number, limit?: number, options?: any): AxiosPromise<ListModuleNotificationSettingsResponseDto> {
            return localVarFp.adminNotificationSettingsControllerListModulesNotificationSettings(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} thresholdSettingId 
         * @param {PatchThresholdSettingsRequestDto} patchThresholdSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerPatchThresholdSettings(thresholdSettingId: string, patchThresholdSettingsRequestDto: PatchThresholdSettingsRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.adminNotificationSettingsControllerPatchThresholdSettings(thresholdSettingId, patchThresholdSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {IntervallNotificationSettingsRequestDto} intervallNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerSetNotificationInterval(moduleNotificationSettingsId: string, intervallNotificationSettingsRequestDto: IntervallNotificationSettingsRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.adminNotificationSettingsControllerSetNotificationInterval(moduleNotificationSettingsId, intervallNotificationSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerToggleModuleNotificationSettings(moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.adminNotificationSettingsControllerToggleModuleNotificationSettings(moduleNotificationSettingsId, toggleModuleNotificationSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} flowControlSensorAssignmentId
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerToggleModuleNotificationSettingsForFlowControlSensor(flowControlSensorAssignmentId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.adminNotificationSettingsControllerToggleModuleNotificationSettingsForFlowControlSensor(flowControlSensorAssignmentId, toggleModuleNotificationSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors(moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors(moduleNotificationSettingsId, toggleModuleNotificationSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateDefaultNotificationSettingsRequestDto} updateDefaultNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerUpdateDefaultNotificationSettings(updateDefaultNotificationSettingsRequestDto: UpdateDefaultNotificationSettingsRequestDto, options?: any): AxiosPromise<DefaultNotificationSettingsDto> {
            return localVarFp.adminNotificationSettingsControllerUpdateDefaultNotificationSettings(updateDefaultNotificationSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} moduleNotificationSettingsId 
         * @param {UpdateModuleNotificationSettingsRequestDto} updateModuleNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationSettingsControllerUpdateModule(moduleNotificationSettingsId: string, updateModuleNotificationSettingsRequestDto: UpdateModuleNotificationSettingsRequestDto, options?: any): AxiosPromise<ModuleNotificationSettingsDto> {
            return localVarFp.adminNotificationSettingsControllerUpdateModule(moduleNotificationSettingsId, updateModuleNotificationSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminNotificationSettingsApi - object-oriented interface
 * @export
 * @class AdminNotificationSettingsApi
 * @extends {BaseAPI}
 */
export class AdminNotificationSettingsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerFindDefaultNotificationSettings(options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerFindDefaultNotificationSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerGetThresholdSettings(moduleId?: string, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerGetThresholdSettings(moduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] current page
     * @param {number} [limit] rows per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerListModulesNotificationSettings(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerListModulesNotificationSettings(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} thresholdSettingId 
     * @param {PatchThresholdSettingsRequestDto} patchThresholdSettingsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerPatchThresholdSettings(thresholdSettingId: string, patchThresholdSettingsRequestDto: PatchThresholdSettingsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerPatchThresholdSettings(thresholdSettingId, patchThresholdSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} moduleNotificationSettingsId 
     * @param {IntervallNotificationSettingsRequestDto} intervallNotificationSettingsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerSetNotificationInterval(moduleNotificationSettingsId: string, intervallNotificationSettingsRequestDto: IntervallNotificationSettingsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerSetNotificationInterval(moduleNotificationSettingsId, intervallNotificationSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} moduleNotificationSettingsId 
     * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerToggleModuleNotificationSettings(moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerToggleModuleNotificationSettings(moduleNotificationSettingsId, toggleModuleNotificationSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} flowControlSensorAssignmentId
     * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerToggleModuleNotificationSettingsForFlowControlSensor(flowControlSensorAssignmentId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerToggleModuleNotificationSettingsForFlowControlSensor(flowControlSensorAssignmentId, toggleModuleNotificationSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} moduleNotificationSettingsId 
     * @param {ToggleModuleNotificationSettingsRequestDto} toggleModuleNotificationSettingsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors(moduleNotificationSettingsId: string, toggleModuleNotificationSettingsRequestDto: ToggleModuleNotificationSettingsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerToggleModuleNotificationSettingsForErrors(moduleNotificationSettingsId, toggleModuleNotificationSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateDefaultNotificationSettingsRequestDto} updateDefaultNotificationSettingsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerUpdateDefaultNotificationSettings(updateDefaultNotificationSettingsRequestDto: UpdateDefaultNotificationSettingsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerUpdateDefaultNotificationSettings(updateDefaultNotificationSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} moduleNotificationSettingsId 
     * @param {UpdateModuleNotificationSettingsRequestDto} updateModuleNotificationSettingsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationSettingsApi
     */
    public adminNotificationSettingsControllerUpdateModule(moduleNotificationSettingsId: string, updateModuleNotificationSettingsRequestDto: UpdateModuleNotificationSettingsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationSettingsApiFp(this.configuration).adminNotificationSettingsControllerUpdateModule(moduleNotificationSettingsId, updateModuleNotificationSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminNotificationsApi - axios parameter creator
 * @export
 */
export const AdminNotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ListNotificationsRequestDto} listNotificationsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerFindMany: async (listNotificationsRequestDto: ListNotificationsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listNotificationsRequestDto' is not null or undefined
            assertParamExists('adminNotificationsControllerFindMany', 'listNotificationsRequestDto', listNotificationsRequestDto)
            const localVarPath = `/admin/notifications/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listNotificationsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerFindUnreadErrorNotifications: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/notifications/unread-error-notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MarkAllNotificationsAsUnread} markAllNotificationsAsUnread 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerMarkAllNotificationsAsRead: async (markAllNotificationsAsUnread: MarkAllNotificationsAsUnread, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'markAllNotificationsAsUnread' is not null or undefined
            assertParamExists('adminNotificationsControllerMarkAllNotificationsAsRead', 'markAllNotificationsAsUnread', markAllNotificationsAsUnread)
            const localVarPath = `/admin/notifications/mark-all-as-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markAllNotificationsAsUnread, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerMarkAllNotificationsAsReadForUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/notifications/mark-all-as-read-for-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerToggleReadStatus: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminNotificationsControllerToggleReadStatus', 'body', body)
            const localVarPath = `/admin/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminNotificationsApi - functional programming interface
 * @export
 */
export const AdminNotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminNotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ListNotificationsRequestDto} listNotificationsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerFindMany(listNotificationsRequestDto: ListNotificationsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNotificationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerFindMany(listNotificationsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerFindUnreadErrorNotifications(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerFindUnreadErrorNotifications(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MarkAllNotificationsAsUnread} markAllNotificationsAsUnread 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerMarkAllNotificationsAsRead(markAllNotificationsAsUnread: MarkAllNotificationsAsUnread, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerMarkAllNotificationsAsRead(markAllNotificationsAsUnread, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerMarkAllNotificationsAsReadForUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerMarkAllNotificationsAsReadForUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerToggleReadStatus(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNotificationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerToggleReadStatus(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminNotificationsApi - factory interface
 * @export
 */
export const AdminNotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminNotificationsApiFp(configuration)
    return {
        /**
         * 
         * @param {ListNotificationsRequestDto} listNotificationsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerFindMany(listNotificationsRequestDto: ListNotificationsRequestDto, options?: any): AxiosPromise<ListNotificationsResponseDto> {
            return localVarFp.adminNotificationsControllerFindMany(listNotificationsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerFindUnreadErrorNotifications(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.adminNotificationsControllerFindUnreadErrorNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MarkAllNotificationsAsUnread} markAllNotificationsAsUnread 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerMarkAllNotificationsAsRead(markAllNotificationsAsUnread: MarkAllNotificationsAsUnread, options?: any): AxiosPromise<object> {
            return localVarFp.adminNotificationsControllerMarkAllNotificationsAsRead(markAllNotificationsAsUnread, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerMarkAllNotificationsAsReadForUser(options?: any): AxiosPromise<object> {
            return localVarFp.adminNotificationsControllerMarkAllNotificationsAsReadForUser(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerToggleReadStatus(body: object, options?: any): AxiosPromise<ListNotificationsResponseDto> {
            return localVarFp.adminNotificationsControllerToggleReadStatus(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminNotificationsApi - object-oriented interface
 * @export
 * @class AdminNotificationsApi
 * @extends {BaseAPI}
 */
export class AdminNotificationsApi extends BaseAPI {
    /**
     * 
     * @param {ListNotificationsRequestDto} listNotificationsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationsApi
     */
    public adminNotificationsControllerFindMany(listNotificationsRequestDto: ListNotificationsRequestDto, options?: AxiosRequestConfig) {
        return AdminNotificationsApiFp(this.configuration).adminNotificationsControllerFindMany(listNotificationsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationsApi
     */
    public adminNotificationsControllerFindUnreadErrorNotifications(options?: AxiosRequestConfig) {
        return AdminNotificationsApiFp(this.configuration).adminNotificationsControllerFindUnreadErrorNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarkAllNotificationsAsUnread} markAllNotificationsAsUnread 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationsApi
     */
    public adminNotificationsControllerMarkAllNotificationsAsRead(markAllNotificationsAsUnread: MarkAllNotificationsAsUnread, options?: AxiosRequestConfig) {
        return AdminNotificationsApiFp(this.configuration).adminNotificationsControllerMarkAllNotificationsAsRead(markAllNotificationsAsUnread, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationsApi
     */
    public adminNotificationsControllerMarkAllNotificationsAsReadForUser(options?: AxiosRequestConfig) {
        return AdminNotificationsApiFp(this.configuration).adminNotificationsControllerMarkAllNotificationsAsReadForUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationsApi
     */
    public adminNotificationsControllerToggleReadStatus(body: object, options?: AxiosRequestConfig) {
        return AdminNotificationsApiFp(this.configuration).adminNotificationsControllerToggleReadStatus(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminRoleApi - axios parameter creator
 * @export
 */
export const AdminRoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerGetAllModuleDiagnosticsLastSeen: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin-role/all-module-diagnostics-last-seen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {'createdAt' | 'email' | 'firstName' | 'lastName' | 'role' | 'username'} [sortBy] 
         * @param {'asc' | 'desc'} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerGetAllUsers: async (page?: number, limit?: number, sortBy?: 'createdAt' | 'email' | 'firstName' | 'lastName' | 'role' | 'username', sortOrder?: 'asc' | 'desc', search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin-role/all-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModulesErrorSummaryRequestDto} modulesErrorSummaryRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerGetModulesErrorSummary: async (modulesErrorSummaryRequestDto: ModulesErrorSummaryRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modulesErrorSummaryRequestDto' is not null or undefined
            assertParamExists('adminRoleControllerGetModulesErrorSummary', 'modulesErrorSummaryRequestDto', modulesErrorSummaryRequestDto)
            const localVarPath = `/admin-role/modules-errors-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modulesErrorSummaryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MimicUserDto} mimicUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerMimicUser: async (mimicUserDto: MimicUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mimicUserDto' is not null or undefined
            assertParamExists('adminRoleControllerMimicUser', 'mimicUserDto', mimicUserDto)
            const localVarPath = `/admin-role/mimic-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mimicUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminRoleApi - functional programming interface
 * @export
 */
export const AdminRoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminRoleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRoleControllerGetAllModuleDiagnosticsLastSeen(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModuleDiagnosticsLastSeenResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRoleControllerGetAllModuleDiagnosticsLastSeen(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {'createdAt' | 'email' | 'firstName' | 'lastName' | 'role' | 'username'} [sortBy] 
         * @param {'asc' | 'desc'} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRoleControllerGetAllUsers(page?: number, limit?: number, sortBy?: 'createdAt' | 'email' | 'firstName' | 'lastName' | 'role' | 'username', sortOrder?: 'asc' | 'desc', search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAllUsersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRoleControllerGetAllUsers(page, limit, sortBy, sortOrder, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ModulesErrorSummaryRequestDto} modulesErrorSummaryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRoleControllerGetModulesErrorSummary(modulesErrorSummaryRequestDto: ModulesErrorSummaryRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModulesErrorSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRoleControllerGetModulesErrorSummary(modulesErrorSummaryRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MimicUserDto} mimicUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRoleControllerMimicUser(mimicUserDto: MimicUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LoginResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRoleControllerMimicUser(mimicUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminRoleApi - factory interface
 * @export
 */
export const AdminRoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminRoleApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerGetAllModuleDiagnosticsLastSeen(options?: any): AxiosPromise<Array<ModuleDiagnosticsLastSeenResponseDto>> {
            return localVarFp.adminRoleControllerGetAllModuleDiagnosticsLastSeen(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {'createdAt' | 'email' | 'firstName' | 'lastName' | 'role' | 'username'} [sortBy] 
         * @param {'asc' | 'desc'} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerGetAllUsers(page?: number, limit?: number, sortBy?: 'createdAt' | 'email' | 'firstName' | 'lastName' | 'role' | 'username', sortOrder?: 'asc' | 'desc', search?: string, options?: any): AxiosPromise<ListAllUsersResponseDto> {
            return localVarFp.adminRoleControllerGetAllUsers(page, limit, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ModulesErrorSummaryRequestDto} modulesErrorSummaryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerGetModulesErrorSummary(modulesErrorSummaryRequestDto: ModulesErrorSummaryRequestDto, options?: any): AxiosPromise<Array<ModulesErrorSummaryDto>> {
            return localVarFp.adminRoleControllerGetModulesErrorSummary(modulesErrorSummaryRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MimicUserDto} mimicUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRoleControllerMimicUser(mimicUserDto: MimicUserDto, options?: any): AxiosPromise<Array<LoginResponseDto>> {
            return localVarFp.adminRoleControllerMimicUser(mimicUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminRoleApi - object-oriented interface
 * @export
 * @class AdminRoleApi
 * @extends {BaseAPI}
 */
export class AdminRoleApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleApi
     */
    public adminRoleControllerGetAllModuleDiagnosticsLastSeen(options?: AxiosRequestConfig) {
        return AdminRoleApiFp(this.configuration).adminRoleControllerGetAllModuleDiagnosticsLastSeen(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] current page
     * @param {number} [limit] rows per page
     * @param {'createdAt' | 'email' | 'firstName' | 'lastName' | 'role' | 'username'} [sortBy] 
     * @param {'asc' | 'desc'} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleApi
     */
    public adminRoleControllerGetAllUsers(page?: number, limit?: number, sortBy?: 'createdAt' | 'email' | 'firstName' | 'lastName' | 'role' | 'username', sortOrder?: 'asc' | 'desc', search?: string, options?: AxiosRequestConfig) {
        return AdminRoleApiFp(this.configuration).adminRoleControllerGetAllUsers(page, limit, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ModulesErrorSummaryRequestDto} modulesErrorSummaryRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleApi
     */
    public adminRoleControllerGetModulesErrorSummary(modulesErrorSummaryRequestDto: ModulesErrorSummaryRequestDto, options?: AxiosRequestConfig) {
        return AdminRoleApiFp(this.configuration).adminRoleControllerGetModulesErrorSummary(modulesErrorSummaryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MimicUserDto} mimicUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleApi
     */
    public adminRoleControllerMimicUser(mimicUserDto: MimicUserDto, options?: AxiosRequestConfig) {
        return AdminRoleApiFp(this.configuration).adminRoleControllerMimicUser(mimicUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminTranslationsApi - axios parameter creator
 * @export
 */
export const AdminTranslationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateTranslationDto} createTranslationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translationsAdminControllerCreate: async (createTranslationDto: CreateTranslationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTranslationDto' is not null or undefined
            assertParamExists('translationsAdminControllerCreate', 'createTranslationDto', createTranslationDto)
            const localVarPath = `/admin/translations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTranslationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translationsAdminControllerDelete: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('translationsAdminControllerDelete', 'key', key)
            const localVarPath = `/admin/translations/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translationsAdminControllerGetOne: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('translationsAdminControllerGetOne', 'key', key)
            const localVarPath = `/admin/translations/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translationsAdminControllerList: async (page?: number, limit?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/translations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {UpdateTranslationDto} updateTranslationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translationsAdminControllerUpdate: async (key: string, updateTranslationDto: UpdateTranslationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('translationsAdminControllerUpdate', 'key', key)
            // verify required parameter 'updateTranslationDto' is not null or undefined
            assertParamExists('translationsAdminControllerUpdate', 'updateTranslationDto', updateTranslationDto)
            const localVarPath = `/admin/translations/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTranslationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminTranslationsApi - functional programming interface
 * @export
 */
export const AdminTranslationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminTranslationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateTranslationDto} createTranslationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async translationsAdminControllerCreate(createTranslationDto: CreateTranslationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranslationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.translationsAdminControllerCreate(createTranslationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async translationsAdminControllerDelete(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.translationsAdminControllerDelete(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async translationsAdminControllerGetOne(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranslationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.translationsAdminControllerGetOne(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async translationsAdminControllerList(page?: number, limit?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTranslationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.translationsAdminControllerList(page, limit, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} key 
         * @param {UpdateTranslationDto} updateTranslationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async translationsAdminControllerUpdate(key: string, updateTranslationDto: UpdateTranslationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranslationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.translationsAdminControllerUpdate(key, updateTranslationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminTranslationsApi - factory interface
 * @export
 */
export const AdminTranslationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminTranslationsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateTranslationDto} createTranslationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translationsAdminControllerCreate(createTranslationDto: CreateTranslationDto, options?: any): AxiosPromise<TranslationDto> {
            return localVarFp.translationsAdminControllerCreate(createTranslationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translationsAdminControllerDelete(key: string, options?: any): AxiosPromise<void> {
            return localVarFp.translationsAdminControllerDelete(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translationsAdminControllerGetOne(key: string, options?: any): AxiosPromise<TranslationDto> {
            return localVarFp.translationsAdminControllerGetOne(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translationsAdminControllerList(page?: number, limit?: number, search?: string, options?: any): AxiosPromise<ListTranslationsResponseDto> {
            return localVarFp.translationsAdminControllerList(page, limit, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} key 
         * @param {UpdateTranslationDto} updateTranslationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translationsAdminControllerUpdate(key: string, updateTranslationDto: UpdateTranslationDto, options?: any): AxiosPromise<TranslationDto> {
            return localVarFp.translationsAdminControllerUpdate(key, updateTranslationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminTranslationsApi - object-oriented interface
 * @export
 * @class AdminTranslationsApi
 * @extends {BaseAPI}
 */
export class AdminTranslationsApi extends BaseAPI {
    /**
     * 
     * @param {CreateTranslationDto} createTranslationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTranslationsApi
     */
    public translationsAdminControllerCreate(createTranslationDto: CreateTranslationDto, options?: AxiosRequestConfig) {
        return AdminTranslationsApiFp(this.configuration).translationsAdminControllerCreate(createTranslationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTranslationsApi
     */
    public translationsAdminControllerDelete(key: string, options?: AxiosRequestConfig) {
        return AdminTranslationsApiFp(this.configuration).translationsAdminControllerDelete(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTranslationsApi
     */
    public translationsAdminControllerGetOne(key: string, options?: AxiosRequestConfig) {
        return AdminTranslationsApiFp(this.configuration).translationsAdminControllerGetOne(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] current page
     * @param {number} [limit] rows per page
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTranslationsApi
     */
    public translationsAdminControllerList(page?: number, limit?: number, search?: string, options?: AxiosRequestConfig) {
        return AdminTranslationsApiFp(this.configuration).translationsAdminControllerList(page, limit, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} key 
     * @param {UpdateTranslationDto} updateTranslationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTranslationsApi
     */
    public translationsAdminControllerUpdate(key: string, updateTranslationDto: UpdateTranslationDto, options?: AxiosRequestConfig) {
        return AdminTranslationsApiFp(this.configuration).translationsAdminControllerUpdate(key, updateTranslationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminUsersApi - axios parameter creator
 * @export
 */
export const AdminUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAssignModule: async (id: string, moduleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUsersControllerAssignModule', 'id', id)
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('adminUsersControllerAssignModule', 'moduleId', moduleId)
            const localVarPath = `/admin/users/{id}/modules/{moduleId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"moduleId"}}`, encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerCreate: async (createUserDto: CreateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserDto' is not null or undefined
            assertParamExists('adminUsersControllerCreate', 'createUserDto', createUserDto)
            const localVarPath = `/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerUnassignModule: async (id: string, moduleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUsersControllerUnassignModule', 'id', id)
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('adminUsersControllerUnassignModule', 'moduleId', moduleId)
            const localVarPath = `/admin/users/{id}/modules/{moduleId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"moduleId"}}`, encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerDeleteUser: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUsersControllerDeleteUser', 'id', id)
            const localVarPath = `/admin/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateUserDto} updateUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerUpdateOne: async (id: string, updateUserDto: UpdateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUsersControllerUpdateOne', 'id', id)
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('adminUsersControllerUpdateOne', 'updateUserDto', updateUserDto)
            const localVarPath = `/admin/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUsersApi - functional programming interface
 * @export
 */
export const AdminUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerAssignModule(id: string, moduleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerAssignModule(id, moduleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerCreate(createUserDto: CreateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllUsersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerCreate(createUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerUnassignModule(id: string, moduleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerUnassignModule(id, moduleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerDeleteUser(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerDeleteUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateUserDto} updateUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerUpdateOne(id: string, updateUserDto: UpdateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllUsersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerUpdateOne(id, updateUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminUsersApi - factory interface
 * @export
 */
export const AdminUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUsersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAssignModule(id: string, moduleId: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminUsersControllerAssignModule(id, moduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerCreate(createUserDto: CreateUserDto, options?: any): AxiosPromise<AllUsersResponseDto> {
            return localVarFp.adminUsersControllerCreate(createUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerUnassignModule(id: string, moduleId: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminUsersControllerUnassignModule(id, moduleId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerDeleteUser(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminUsersControllerDeleteUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateUserDto} updateUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerUpdateOne(id: string, updateUserDto: UpdateUserDto, options?: any): AxiosPromise<AllUsersResponseDto> {
            return localVarFp.adminUsersControllerUpdateOne(id, updateUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminUsersApi - object-oriented interface
 * @export
 * @class AdminUsersApi
 * @extends {BaseAPI}
 */
export class AdminUsersApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} moduleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUsersControllerAssignModule(id: string, moduleId: string, options?: AxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUsersControllerAssignModule(id, moduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateUserDto} createUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUsersControllerCreate(createUserDto: CreateUserDto, options?: AxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUsersControllerCreate(createUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} moduleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUsersControllerUnassignModule(id: string, moduleId: string, options?: AxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUsersControllerUnassignModule(id, moduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUsersControllerDeleteUser(id: string, options?: AxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUsersControllerDeleteUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} id
     * @param {UpdateUserDto} updateUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUsersControllerUpdateOne(id: string, updateUserDto: UpdateUserDto, options?: AxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUsersControllerUpdateOne(id, updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminVideoJobsApi - axios parameter creator
 * @export
 */
export const AdminVideoJobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Requests cancellation of a not-yet-finished job — the encoder is the source of truth for the resulting status, delivered asynchronously via the existing RabbitMQ response flow and the real-time socket update.
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVideoJobsControllerCancel: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminVideoJobsControllerCancel', 'id', id)
            const localVarPath = `/admin/video-jobs/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates the tracking record and publishes the encode job — returns immediately with status PENDING, it does not wait for the encoder. Poll GET /admin/video-jobs/:id for progress and the generated file name.
         * @summary 
         * @param {CreateVideoJobDto} createVideoJobDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVideoJobsControllerCreate: async (createVideoJobDto: CreateVideoJobDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createVideoJobDto' is not null or undefined
            assertParamExists('adminVideoJobsControllerCreate', 'createVideoJobDto', createVideoJobDto)
            const localVarPath = `/admin/video-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVideoJobDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVideoJobsControllerFindMany: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/video-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVideoJobsControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminVideoJobsControllerFindOne', 'id', id)
            const localVarPath = `/admin/video-jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVideoJobsControllerRemove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminVideoJobsControllerRemove', 'id', id)
            const localVarPath = `/admin/video-jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminVideoJobsApi - functional programming interface
 * @export
 */
export const AdminVideoJobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminVideoJobsApiAxiosParamCreator(configuration)
    return {
        /**
         * Requests cancellation of a not-yet-finished job — the encoder is the source of truth for the resulting status, delivered asynchronously via the existing RabbitMQ response flow and the real-time socket update.
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVideoJobsControllerCancel(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoJobDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVideoJobsControllerCancel(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates the tracking record and publishes the encode job — returns immediately with status PENDING, it does not wait for the encoder. Poll GET /admin/video-jobs/:id for progress and the generated file name.
         * @summary 
         * @param {CreateVideoJobDto} createVideoJobDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVideoJobsControllerCreate(createVideoJobDto: CreateVideoJobDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoJobDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVideoJobsControllerCreate(createVideoJobDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVideoJobsControllerFindMany(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListVideoJobsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVideoJobsControllerFindMany(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVideoJobsControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoJobDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVideoJobsControllerFindOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVideoJobsControllerRemove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoJobDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVideoJobsControllerRemove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminVideoJobsApi - factory interface
 * @export
 */
export const AdminVideoJobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminVideoJobsApiFp(configuration)
    return {
        /**
         * Requests cancellation of a not-yet-finished job — the encoder is the source of truth for the resulting status, delivered asynchronously via the existing RabbitMQ response flow and the real-time socket update.
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVideoJobsControllerCancel(id: string, options?: any): AxiosPromise<VideoJobDto> {
            return localVarFp.adminVideoJobsControllerCancel(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates the tracking record and publishes the encode job — returns immediately with status PENDING, it does not wait for the encoder. Poll GET /admin/video-jobs/:id for progress and the generated file name.
         * @summary 
         * @param {CreateVideoJobDto} createVideoJobDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVideoJobsControllerCreate(createVideoJobDto: CreateVideoJobDto, options?: any): AxiosPromise<VideoJobDto> {
            return localVarFp.adminVideoJobsControllerCreate(createVideoJobDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] current page
         * @param {number} [limit] rows per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVideoJobsControllerFindMany(page?: number, limit?: number, options?: any): AxiosPromise<ListVideoJobsResponseDto> {
            return localVarFp.adminVideoJobsControllerFindMany(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVideoJobsControllerFindOne(id: string, options?: any): AxiosPromise<VideoJobDto> {
            return localVarFp.adminVideoJobsControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVideoJobsControllerRemove(id: string, options?: any): AxiosPromise<VideoJobDto> {
            return localVarFp.adminVideoJobsControllerRemove(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminVideoJobsApi - object-oriented interface
 * @export
 * @class AdminVideoJobsApi
 * @extends {BaseAPI}
 */
export class AdminVideoJobsApi extends BaseAPI {
    /**
     * Requests cancellation of a not-yet-finished job — the encoder is the source of truth for the resulting status, delivered asynchronously via the existing RabbitMQ response flow and the real-time socket update.
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVideoJobsApi
     */
    public adminVideoJobsControllerCancel(id: string, options?: AxiosRequestConfig) {
        return AdminVideoJobsApiFp(this.configuration).adminVideoJobsControllerCancel(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates the tracking record and publishes the encode job — returns immediately with status PENDING, it does not wait for the encoder. Poll GET /admin/video-jobs/:id for progress and the generated file name.
     * @summary 
     * @param {CreateVideoJobDto} createVideoJobDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVideoJobsApi
     */
    public adminVideoJobsControllerCreate(createVideoJobDto: CreateVideoJobDto, options?: AxiosRequestConfig) {
        return AdminVideoJobsApiFp(this.configuration).adminVideoJobsControllerCreate(createVideoJobDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] current page
     * @param {number} [limit] rows per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVideoJobsApi
     */
    public adminVideoJobsControllerFindMany(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return AdminVideoJobsApiFp(this.configuration).adminVideoJobsControllerFindMany(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVideoJobsApi
     */
    public adminVideoJobsControllerFindOne(id: string, options?: AxiosRequestConfig) {
        return AdminVideoJobsApiFp(this.configuration).adminVideoJobsControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVideoJobsApi
     */
    public adminVideoJobsControllerRemove(id: string, options?: AxiosRequestConfig) {
        return AdminVideoJobsApiFp(this.configuration).adminVideoJobsControllerRemove(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerGetHealth: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthControllerGetHealth(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HealthControllerGetHealth200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthControllerGetHealth(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerGetHealth(options?: any): AxiosPromise<HealthControllerGetHealth200Response> {
            return localVarFp.healthControllerGetHealth(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public healthControllerGetHealth(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).healthControllerGetHealth(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QualicamApi - axios parameter creator
 * @export
 */
export const QualicamApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {QualicamEntryDto} qualicamEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerCreateQualicamEntry: async (qualicamEntryDto: QualicamEntryDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'qualicamEntryDto' is not null or undefined
            assertParamExists('qualicamControllerCreateQualicamEntry', 'qualicamEntryDto', qualicamEntryDto)
            const localVarPath = `/qualicam`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(qualicamEntryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} qualicamName 
         * @param {number} limit 
         * @param {number} page 
         * @param {Array<string>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerGetQualicamEntry: async (qualicamName: string, limit: number, page: number, filter?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'qualicamName' is not null or undefined
            assertParamExists('qualicamControllerGetQualicamEntry', 'qualicamName', qualicamName)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('qualicamControllerGetQualicamEntry', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('qualicamControllerGetQualicamEntry', 'page', page)
            const localVarPath = `/qualicam/{qualicam_name}`
                .replace(`{${"qualicam_name"}}`, encodeURIComponent(String(qualicamName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerGetQualicamEntryOverview: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/qualicam/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} qualicamName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerGetQualicamMetaData: async (qualicamName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'qualicamName' is not null or undefined
            assertParamExists('qualicamControllerGetQualicamMetaData', 'qualicamName', qualicamName)
            const localVarPath = `/qualicam/{qualicam_name}/metadata`
                .replace(`{${"qualicam_name"}}`, encodeURIComponent(String(qualicamName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QualicamApi - functional programming interface
 * @export
 */
export const QualicamApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QualicamApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {QualicamEntryDto} qualicamEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qualicamControllerCreateQualicamEntry(qualicamEntryDto: QualicamEntryDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualicamEntryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qualicamControllerCreateQualicamEntry(qualicamEntryDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} qualicamName 
         * @param {number} limit 
         * @param {number} page 
         * @param {Array<string>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qualicamControllerGetQualicamEntry(qualicamName: string, limit: number, page: number, filter?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualicamEntriesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qualicamControllerGetQualicamEntry(qualicamName, limit, page, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qualicamControllerGetQualicamEntryOverview(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QualicamEntryOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qualicamControllerGetQualicamEntryOverview(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} qualicamName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qualicamControllerGetQualicamMetaData(qualicamName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualicamEntryOverviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qualicamControllerGetQualicamMetaData(qualicamName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QualicamApi - factory interface
 * @export
 */
export const QualicamApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QualicamApiFp(configuration)
    return {
        /**
         * 
         * @param {QualicamEntryDto} qualicamEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerCreateQualicamEntry(qualicamEntryDto: QualicamEntryDto, options?: any): AxiosPromise<QualicamEntryDto> {
            return localVarFp.qualicamControllerCreateQualicamEntry(qualicamEntryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} qualicamName 
         * @param {number} limit 
         * @param {number} page 
         * @param {Array<string>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerGetQualicamEntry(qualicamName: string, limit: number, page: number, filter?: Array<string>, options?: any): AxiosPromise<QualicamEntriesResponseDto> {
            return localVarFp.qualicamControllerGetQualicamEntry(qualicamName, limit, page, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerGetQualicamEntryOverview(options?: any): AxiosPromise<Array<QualicamEntryOverviewDto>> {
            return localVarFp.qualicamControllerGetQualicamEntryOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} qualicamName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qualicamControllerGetQualicamMetaData(qualicamName: string, options?: any): AxiosPromise<QualicamEntryOverviewDto> {
            return localVarFp.qualicamControllerGetQualicamMetaData(qualicamName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QualicamApi - object-oriented interface
 * @export
 * @class QualicamApi
 * @extends {BaseAPI}
 */
export class QualicamApi extends BaseAPI {
    /**
     * 
     * @param {QualicamEntryDto} qualicamEntryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualicamApi
     */
    public qualicamControllerCreateQualicamEntry(qualicamEntryDto: QualicamEntryDto, options?: AxiosRequestConfig) {
        return QualicamApiFp(this.configuration).qualicamControllerCreateQualicamEntry(qualicamEntryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} qualicamName 
     * @param {number} limit 
     * @param {number} page 
     * @param {Array<string>} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualicamApi
     */
    public qualicamControllerGetQualicamEntry(qualicamName: string, limit: number, page: number, filter?: Array<string>, options?: AxiosRequestConfig) {
        return QualicamApiFp(this.configuration).qualicamControllerGetQualicamEntry(qualicamName, limit, page, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualicamApi
     */
    public qualicamControllerGetQualicamEntryOverview(options?: AxiosRequestConfig) {
        return QualicamApiFp(this.configuration).qualicamControllerGetQualicamEntryOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} qualicamName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualicamApi
     */
    public qualicamControllerGetQualicamMetaData(qualicamName: string, options?: AxiosRequestConfig) {
        return QualicamApiFp(this.configuration).qualicamControllerGetQualicamMetaData(qualicamName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TranslationsApi - axios parameter creator
 * @export
 */
export const TranslationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} languageCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translationsControllerGetTranslations: async (languageCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'languageCode' is not null or undefined
            assertParamExists('translationsControllerGetTranslations', 'languageCode', languageCode)
            const localVarPath = `/translations/{languageCode}`
                .replace(`{${"languageCode"}}`, encodeURIComponent(String(languageCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranslationsApi - functional programming interface
 * @export
 */
export const TranslationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TranslationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} languageCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async translationsControllerGetTranslations(languageCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.translationsControllerGetTranslations(languageCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TranslationsApi - factory interface
 * @export
 */
export const TranslationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TranslationsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} languageCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translationsControllerGetTranslations(languageCode: string, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.translationsControllerGetTranslations(languageCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TranslationsApi - object-oriented interface
 * @export
 * @class TranslationsApi
 * @extends {BaseAPI}
 */
export class TranslationsApi extends BaseAPI {
    /**
     * 
     * @param {string} languageCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationsApi
     */
    public translationsControllerGetTranslations(languageCode: string, options?: AxiosRequestConfig) {
        return TranslationsApiFp(this.configuration).translationsControllerGetTranslations(languageCode, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserAuthApi - axios parameter creator
 * @export
 */
export const UserAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LoginRequestDto} loginRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthControllerLogin: async (loginRequestDto: LoginRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequestDto' is not null or undefined
            assertParamExists('userAuthControllerLogin', 'loginRequestDto', loginRequestDto)
            const localVarPath = `/user/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthControllerValidateToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/auth/validate-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAuthApi - functional programming interface
 * @export
 */
export const UserAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LoginRequestDto} loginRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAuthControllerLogin(loginRequestDto: LoginRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAuthControllerLogin(loginRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAuthControllerValidateToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAuthControllerValidateToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserAuthApi - factory interface
 * @export
 */
export const UserAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserAuthApiFp(configuration)
    return {
        /**
         * 
         * @param {LoginRequestDto} loginRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthControllerLogin(loginRequestDto: LoginRequestDto, options?: any): AxiosPromise<LoginResponseDto> {
            return localVarFp.userAuthControllerLogin(loginRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAuthControllerValidateToken(options?: any): AxiosPromise<string> {
            return localVarFp.userAuthControllerValidateToken(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserAuthApi - object-oriented interface
 * @export
 * @class UserAuthApi
 * @extends {BaseAPI}
 */
export class UserAuthApi extends BaseAPI {
    /**
     * 
     * @param {LoginRequestDto} loginRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthApi
     */
    public userAuthControllerLogin(loginRequestDto: LoginRequestDto, options?: AxiosRequestConfig) {
        return UserAuthApiFp(this.configuration).userAuthControllerLogin(loginRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthApi
     */
    public userAuthControllerValidateToken(options?: AxiosRequestConfig) {
        return UserAuthApiFp(this.configuration).userAuthControllerValidateToken(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ChangePasswordRequestDto} changePasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerChangePassword: async (changePasswordRequestDto: ChangePasswordRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordRequestDto' is not null or undefined
            assertParamExists('usersControllerChangePassword', 'changePasswordRequestDto', changePasswordRequestDto)
            const localVarPath = `/users/me/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerFindCurrentUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateLanguageRequestDto} updateLanguageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdateLanguage: async (updateLanguageRequestDto: UpdateLanguageRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateLanguageRequestDto' is not null or undefined
            assertParamExists('usersControllerUpdateLanguage', 'updateLanguageRequestDto', updateLanguageRequestDto)
            const localVarPath = `/users/me/language`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLanguageRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hand-added - see SubscribeToPushRequestDto's comment above.
         * @param {SubscribeToPushRequestDto} subscribeToPushRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSubscribeToPush: async (subscribeToPushRequestDto: SubscribeToPushRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscribeToPushRequestDto' is not null or undefined
            assertParamExists('usersControllerSubscribeToPush', 'subscribeToPushRequestDto', subscribeToPushRequestDto)
            const localVarPath = `/users/me/push-subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscribeToPushRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hand-added - see SubscribeToPushRequestDto's comment above.
         * @param {UnsubscribeFromPushRequestDto} unsubscribeFromPushRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUnsubscribeFromPush: async (unsubscribeFromPushRequestDto: UnsubscribeFromPushRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unsubscribeFromPushRequestDto' is not null or undefined
            assertParamExists('usersControllerUnsubscribeFromPush', 'unsubscribeFromPushRequestDto', unsubscribeFromPushRequestDto)
            const localVarPath = `/users/me/push-subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unsubscribeFromPushRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ChangePasswordRequestDto} changePasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerChangePassword(changePasswordRequestDto: ChangePasswordRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerChangePassword(changePasswordRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerFindCurrentUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentUserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerFindCurrentUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateLanguageRequestDto} updateLanguageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerUpdateLanguage(updateLanguageRequestDto: UpdateLanguageRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerUpdateLanguage(updateLanguageRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {SubscribeToPushRequestDto} subscribeToPushRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerSubscribeToPush(subscribeToPushRequestDto: SubscribeToPushRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerSubscribeToPush(subscribeToPushRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {UnsubscribeFromPushRequestDto} unsubscribeFromPushRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerUnsubscribeFromPush(unsubscribeFromPushRequestDto: UnsubscribeFromPushRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerUnsubscribeFromPush(unsubscribeFromPushRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {ChangePasswordRequestDto} changePasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerChangePassword(changePasswordRequestDto: ChangePasswordRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.usersControllerChangePassword(changePasswordRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerFindCurrentUser(options?: any): AxiosPromise<CurrentUserResponseDto> {
            return localVarFp.usersControllerFindCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateLanguageRequestDto} updateLanguageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdateLanguage(updateLanguageRequestDto: UpdateLanguageRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.usersControllerUpdateLanguage(updateLanguageRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubscribeToPushRequestDto} subscribeToPushRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSubscribeToPush(subscribeToPushRequestDto: SubscribeToPushRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.usersControllerSubscribeToPush(subscribeToPushRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UnsubscribeFromPushRequestDto} unsubscribeFromPushRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUnsubscribeFromPush(unsubscribeFromPushRequestDto: UnsubscribeFromPushRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.usersControllerUnsubscribeFromPush(unsubscribeFromPushRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {ChangePasswordRequestDto} changePasswordRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerChangePassword(changePasswordRequestDto: ChangePasswordRequestDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerChangePassword(changePasswordRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerFindCurrentUser(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerFindCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateLanguageRequestDto} updateLanguageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerUpdateLanguage(updateLanguageRequestDto: UpdateLanguageRequestDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerUpdateLanguage(updateLanguageRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {SubscribeToPushRequestDto} subscribeToPushRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerSubscribeToPush(subscribeToPushRequestDto: SubscribeToPushRequestDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerSubscribeToPush(subscribeToPushRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {UnsubscribeFromPushRequestDto} unsubscribeFromPushRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerUnsubscribeFromPush(unsubscribeFromPushRequestDto: UnsubscribeFromPushRequestDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerUnsubscribeFromPush(unsubscribeFromPushRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


